import React, { useState, useEffect, useRef, forwardRef } from 'react';
import NavbarBase, { useNavbarBaseContext } from '@lendi-ui/navbar-base';
import { trackEvent, EventCategory, ButtonType, CustomerType } from '@lendi/analytics';
import { gte, between, map, useBreakpoint } from '@lendi-ui/breakpoint';
import Logo from '@lendi-ui/logo';
import { mb, ml, pl, pr, mr, p, px, py, mx, mt, m, pb, pt, my } from '@lendi-ui/spacing';
import { select, useTheme } from '@lendi/ui/Theme';
import styled, { css, keyframes, createGlobalStyle } from 'styled-components';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { Button, IconButton } from '@lendi-ui/button';
import UnreadMessage from '@lendi-ui/icon/UnreadMessage';
import { display, normalise, deriveSize } from '@lendi-ui/utils';
import MoreVert from '@lendi-ui/icon/MoreVert';
import { getBrandFromHostname, Brand, getURLs, SESSION_STORAGE_KEYS, getAPIBaseURL } from '@lendi/lala-utils';
import { useFlags, withLendiLDProvider } from '@lendi/launchdarkly';
import { getRadius, getFocusRing } from '@lendi-ui/commons/borders';
import getColour, { getColour as getColour$1 } from '@lendi-ui/commons/colours';
import { depth } from '@lendi-ui/depth';
import Launch from '@lendi-ui/icon/Launch';
import { Body, Link, Heading } from '@lendi-ui/typography';
import { useSession, Type, Brand as Brand$1, Environment, Status } from '@lendi/lala-react';
import { useBootstrappedChatState, Chat as Chat$1, withCustomerChatProvider, ChatDataExposureContext } from '@lendi/chat';
export { CustomerChatBootstrapperProvider as CommPanelProvider, useBootstrappedChatState as useCommPanel } from '@lendi/chat';
import Close from '@lendi-ui/icon/Close';
import { color, bg, fg } from '@lendi-ui/color';
import Face from '@lendi-ui/icon/Face';
import getTypography from '@lendi-ui/commons/typography';
import { getThemeName, pxToRem, filterGlobalProps, srOnly } from '@lendi-ui/commons/utils';
import Phone from '@lendi-ui/icon/Phone';
import Calendar from '@lendi-ui/icon/Calendar';
import { LendiGroupLeads } from '@lendi/lendigroup-leads-library';
import Chat from '@lendi-ui/icon/Chat';
import KeyboardArrowDown from '@lendi-ui/icon/KeyboardArrowDown';
import KeyboardArrowRight from '@lendi-ui/icon/KeyboardArrowRight';
import KeyboardArrowLeft from '@lendi-ui/icon/KeyboardArrowLeft';
import FocusLock from 'react-focus-lock';
import Menu from '@lendi-ui/icon/Menu';
import Sidebar from '@lendi-ui/sidebar';
import ArrowDropDown from '@lendi-ui/icon/ArrowDropDown';
import ExitToApp from '@lendi-ui/icon/ExitToApp';
import ExpandMore from '@lendi-ui/icon/ExpandMore';
import { grid, unit } from '@lendi-ui/grid';
import ChevronDown from '@lendi-ui/icon/ChevronDown';
import ChevronUp from '@lendi-ui/icon/ChevronUp';
import { Wrapper, Spacer } from '@lendi/ui/Layout';
import ArrowForward from '@lendi-ui/icon/ArrowForward';
import { Text } from '@lendi/ui/Typography';
import { Button as Button$1, AnchorButton } from '@lendi/ui/Button';
import axios from 'axios';

function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

var analytics = navbarAnalyticsEvent => {
  if (window && window.analytics) {
    trackEvent(_objectSpread2({}, navbarAnalyticsEvent));
  } else {
    if (process.env.NODE_ENV === 'development') {
      // gives us the indication of what events are being fired
      // eslint-disable-next-line no-console
      console.log('event', _objectSpread2({}, navbarAnalyticsEvent));
    } else {
      // eslint-disable-next-line no-console
      console.error('Segment is not loaded');
    }
  }
};

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject$g, _templateObject2$6, _templateObject3$2, _templateObject4$1, _templateObject5$1;
var StyledHeaderLogo = styled(Logo).withConfig({
  displayName: "style__StyledHeaderLogo",
  componentId: "lui__sc-17ip4hk-0"
})(["", ";width:auto;height:28px;color:", ";", ";"], _ref => {
  var {
    isHref
  } = _ref;
  return isHref ? css(["cursor:pointer;"]) : css(["cursor:auto;"]);
}, _ref2 => {
  var {
    variant
  } = _ref2;
  return variant === 'dark' ? 'secondary.900' : 'shade.0';
}, _ref3 => {
  var {
    theme
  } = _ref3;
  return select('logo.logoName')({
    theme
  }) === 'LendiLogo' ? css(["", ";", ";"], gte('tablet')(_templateObject$g || (_templateObject$g = _taggedTemplateLiteral(["\n            width: auto;\n            height: 28px;\n          "]))), gte('desktop')(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteral(["\n            width: auto;\n            height: 36px;\n          "])))) : css(["", ";", ";"], gte('tablet')(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral(["\n            width: auto;\n            height: 28px;\n          "]))), gte('desktop')(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n            width: auto;\n            height: 36px;\n          "]))));
});
var LogoLink$1 = styled.a.withConfig({
  displayName: "style__LogoLink",
  componentId: "lui__sc-17ip4hk-1"
})([""]);
var LogoWrapper = styled.div.withConfig({
  displayName: "style__LogoWrapper",
  componentId: "lui__sc-17ip4hk-2"
})(["", ";", ";", ";"], mb('xxxs'), _ref4 => {
  var {
    hasHamburgerMenu
  } = _ref4;
  return hasHamburgerMenu ? css(["", ""], ml('xs')) : css(["", ""], ml('nil'));
}, gte('desktop')(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral(["\n    ", "\n    margin-bottom: 5px;\n  "])), ml('nil')));

var LogoComponent = _ref => {
  var {
    homeURL,
    params,
    hasHamburgerMenu = true
  } = _ref;
  var {
    isTransparent
  } = useNavbarBaseContext();
  var variant = isTransparent ? 'light' : 'dark';
  return /*#__PURE__*/jsx(LogoWrapper, {
    hasHamburgerMenu: hasHamburgerMenu,
    children: homeURL ? /*#__PURE__*/jsx(LogoLink$1, {
      href: "".concat(homeURL).concat(params),
      "aria-label": "Logo",
      onClick: () => {
        var event = {
          event_name: 'Link Clicked',
          category: EventCategory.NAVBAR,
          text: 'Logo',
          linkType: 'Logo'
        };
        analytics(event);
      },
      children: /*#__PURE__*/jsx(StyledHeaderLogo, {
        variant: variant,
        isHref: true
      })
    }) : /*#__PURE__*/jsx(LogoLink$1, {
      children: /*#__PURE__*/jsx(StyledHeaderLogo, {
        variant: variant,
        "aria-label": "Logo",
        isHref: false
      })
    })
  });
};
var LogoComponent$1 = LogoComponent;

var _templateObject$f;
var navTokens = {
  size: {
    height: {
      navbar: {
        mobile: {
          value: '3.5rem'
        },
        desktop: {
          value: '5.5rem'
        }
      }
    }
  }
};
var NavbarWrapper = styled(NavbarBase).withConfig({
  displayName: "styles__NavbarWrapper",
  componentId: "lui__sc-ej7i4l-0"
})(["", ";", " height:", ";", ";"], pl({
  mobile: 'sm',
  tablet: 'sm',
  desktop: 'lg'
}), _ref => {
  var {
    isAuthenticated
  } = _ref;
  return isAuthenticated ? css(["", ";"], pr('nil')) : css(["", ";"], pr({
    mobile: 'sm',
    tablet: 'sm',
    desktop: 'lg'
  }));
}, navTokens.size.height.navbar.mobile.value, gte('desktop')(_templateObject$f || (_templateObject$f = _taggedTemplateLiteral(["\n    height: ", "\n  "])), navTokens.size.height.navbar.desktop.value));
var Container = styled.div.withConfig({
  displayName: "styles__Container",
  componentId: "lui__sc-ej7i4l-1"
})(["display:flex;align-items:center;"]);
var MenuLogoWrapper = styled.div.withConfig({
  displayName: "styles__MenuLogoWrapper",
  componentId: "lui__sc-ej7i4l-2"
})(["display:flex;align-items:center;"]);
var NavbarLeftWrapper = styled.div.withConfig({
  displayName: "styles__NavbarLeftWrapper",
  componentId: "lui__sc-ej7i4l-3"
})(["flex:1 0 auto;"]);
var NavbarRightWrapper = styled.div.withConfig({
  displayName: "styles__NavbarRightWrapper",
  componentId: "lui__sc-ej7i4l-4"
})([""]);

var _templateObject$e, _templateObject2$5;
var TalkExpertAction$1 = styled(Button).withConfig({
  displayName: "style__TalkExpertAction",
  componentId: "lui__sc-9anjvz-0"
})(["width:100%;", " ", ";min-width:180px;", ""], mr('sm'), between('mobile', 'desktop')(_templateObject$e || (_templateObject$e = _taggedTemplateLiteral(["\n    border: none;\n  "]))), _ref => {
  var {
    bigLabelAccomodate
  } = _ref;
  return bigLabelAccomodate && css(["min-width:202px;"]);
});
var TalkExpertActionMobile = styled(Button).withConfig({
  displayName: "style__TalkExpertActionMobile",
  componentId: "lui__sc-9anjvz-1"
})(["", " ", ";min-width:102px;padding:0;line-height:1.33;", ""], mr('sm'), between('mobile', 'desktop')(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteral(["\n    border: none;\n  "]))), _ref2 => {
  var {
    isContinue
  } = _ref2;
  return isContinue && css(["min-width:90px;"]);
});
var SecondaryAction = styled(Button).withConfig({
  displayName: "style__SecondaryAction",
  componentId: "lui__sc-9anjvz-2"
})(["min-width:180px;", " word-wrap:break-word;"], _ref3 => {
  var {
    bigLabelAccomodate
  } = _ref3;
  return bigLabelAccomodate && css(["min-width:202px;"]);
});
var SecondaryActionMobile = styled(Button).withConfig({
  displayName: "style__SecondaryActionMobile",
  componentId: "lui__sc-9anjvz-3"
})(["width:90px;padding:0;"]);
styled.div.withConfig({
  displayName: "style__DesktopLogoutWrapper",
  componentId: "lui__sc-9anjvz-4"
})(["", ""], display({
  mobile: 'none',
  desktop: 'block'
}));
var UnreadMessageWrapper = styled(UnreadMessage).withConfig({
  displayName: "style__UnreadMessageWrapper",
  componentId: "lui__sc-9anjvz-5"
})(["margin-top:-0.4em;margin-right:0.5em;margin-left:-0.5em;"]);

var BOOK_AN_APPOINTMENT = 'BOOK AN APPOINTMENT';
var UNREAD_MESSAGE = 'YOU HAVE AN UNREAD MESSAGE';
var UNREAD_MESSAGE_MOBILE = 'UNREAD MESSAGE';
var CONTACT_US = 'CONTACT US';
var LABEL_TALK_TO_EXPERT = 'TALK TO AN EXPERT';
var LABEL_TALK_TO_A_BROKER = 'TALK TO A BROKER';
var LABEL_SIGN_IN = 'SIGN IN';
var LABEL_CONTINUE = 'CONTINUE';
var LABEL_APPLICATIONS = 'Applications';
var LABEL_DASHBOARD = 'Dashboard';
var LABEL_PROPERTY_REPORT = 'Property reports';
var LABEL_REFER_A_FRIEND = 'Refer a friend';
var LABEL_SEND_FEEDBACK = 'Send Feedback';
var LABEL_LOG_OUT = 'Sign out';
var LABEL_MORE_OPTIONS = 'More options';
var DASHBOARD_V2_PATH = '/v2/dashboard';
var PATH_LENDI = '';
var PATH_DOMAIN = '/loanfinder';
var ROUTE_SIGN_IN = '/sign-in';
var ROUTE_BOOK_APPOINTMENT = '/book-appointment/';
var ROUTE_APPLICATIONS = '/dashboard/applications';
var ROUTE_PROPERTY_REPORT = '/dashboard/my-property-report';
var ROUTE_REFER_A_FRIEND = '/referral';
var ROUTE_NEW_PROPERTY_REPORT = '/property-report/my-properties';
var CMS_AHL_MAIN_URL_MATCH = /^\/?home-loans\/aussies-own-home-loans\/?$/gm;
var CMS_AHL_ACTIVATE_URL_MATCH = /^\/?home-loans\/aussies-own-home-loans\/aussie-activate\/?$/gm;
var CMS_AHL_ELEVATE_URL_MATCH = /^\/?home-loans\/aussies-own-home-loans\/aussie-elevate\/?$/gm;
var CMS_AHL_SELECT_URL_MATCH = /^\/?home-loans\/aussies-own-home-loans\/aussie-select\/?$/gm;
var FUNNEL1_URL_MATCH = /^\/?home-loans\/basics\/?([a-zA-Z0-9.%?=\-]*\/?)*$/gm;
var AHLProducts = /*#__PURE__*/function (AHLProducts) {
  AHLProducts["AUSSIE_ACTIVATE"] = "aussie-activate";
  AHLProducts["AUSSIE_ELEVATE"] = "aussie-elevate";
  AHLProducts["AUSSIE_SELECT"] = "aussie-select";
  return AHLProducts;
}({});
var SURVEY_ID = '931186d4c71ec937';

var _templateObject$d;
var TalkExpertAction = styled(Button).withConfig({
  displayName: "indexstyle__TalkExpertAction",
  componentId: "lui__sc-altm9z-0"
})(["", ";", " min-width:202px;", ";", ""], mr('sm'), _ref => {
  var {
    dashboardVariant
  } = _ref;
  return dashboardVariant && css(["", ""], mr('nil'));
}, between('mobile', 'desktop')(_templateObject$d || (_templateObject$d = _taggedTemplateLiteral(["\n  min-width: 90px;\n    border: none;\n    ", "\n  "])), p('nil')), _ref2 => {
  var {
    continueExist
  } = _ref2;
  return continueExist && css(["min-width:180px;"]);
});
var ContinueAction = styled(Button).withConfig({
  displayName: "indexstyle__ContinueAction",
  componentId: "lui__sc-altm9z-1"
})(["width:90px;padding:0;"]);

var initialState = {
  hideDashboardItem: false,
  hideManageApplicationsItem: false,
  onLogout: undefined
};

var DropdownMenuContext = /*#__PURE__*/React.createContext(initialState);
var useDropdownMenu = () => {
  var state = React.useContext(DropdownMenuContext);
  if (!state) {
    throw new Error('Please setup <DropdownMenuProvider /> as a parent component, before using useDropdownMenu().');
  }
  return state;
};

var _templateObject$c;
var LogoutWrapper = styled.div.withConfig({
  displayName: "style__LogoutWrapper",
  componentId: "lui__sc-t6my6e-0"
})(["position:absolute;right:5px;top:56px;", ";display:flex;flex-direction:column;justify-content:center;align-items:center;background-color:", ";border-radius:", ";", ""], gte('desktop')(_templateObject$c || (_templateObject$c = _taggedTemplateLiteral(["top: 70px;"]))), _ref => {
  var {
    theme
  } = _ref;
  return theme.color.text.inverse;
}, () => getRadius(), depth(2));
var MenuItem$1 = css(["", " ", ""], px('sm'), py('sm'));
var MyAccountTitle = styled(Body).withConfig({
  displayName: "style__MyAccountTitle",
  componentId: "lui__sc-t6my6e-1"
})(["", ";font-weight:bold;width:100%;box-sizing:border-box;border-bottom:1px solid ", ";"], MenuItem$1, () => getColour('shade', 100));
var LinkWrapper$1 = styled(Link).withConfig({
  displayName: "style__LinkWrapper",
  componentId: "lui__sc-t6my6e-2"
})(["", ";overflow:hidden;text-decoration:none;font-weight:normal;width:100%;text-align:left;box-sizing:border-box;background-color:transparent;"], MenuItem$1);
var LaunchIcon = styled(Launch).withConfig({
  displayName: "style__LaunchIcon",
  componentId: "lui__sc-t6my6e-3"
})(["", ""], mx('xl'));

var checkSVA = () => {
  if (typeof window !== undefined && window._sva !== undefined) {
    return window._sva;
  }
  return false;
};
var sendFeedBackOnClick = () => {
  window._sva.showSurvey(SURVEY_ID, {
    forceDisplay: true
  });
};

var DropdownMenu = () => {
  var {
    brand
  } = useSession();
  var isDomain = getBrandFromHostname() === Brand.Domain;
  var isLendi = brand === Brand.Lendi;
  var isSVA = checkSVA();
  var path = isDomain ? PATH_DOMAIN : PATH_LENDI;
  var {
    hideDashboardItem,
    hideManageApplicationsItem,
    onLogout
  } = useDropdownMenu();
  var {
    newPropertyReports,
    sendFeedback,
    referAFriend
  } = useFlags();
  return /*#__PURE__*/jsxs(LogoutWrapper, {
    children: [/*#__PURE__*/jsx(MyAccountTitle, {
      children: "My account"
    }), !hideManageApplicationsItem && /*#__PURE__*/jsx(LinkWrapper$1, {
      color: "shade.700",
      onClick: () => {
        var event = {
          event_name: 'Menu Element Clicked',
          category: EventCategory.NAVBAR,
          menuName: 'Kebab Menu',
          text: LABEL_APPLICATIONS
        };
        analytics(event);
      },
      href: "".concat(path).concat(ROUTE_APPLICATIONS),
      "aria-label": LABEL_APPLICATIONS,
      children: LABEL_APPLICATIONS
    }), !hideDashboardItem && /*#__PURE__*/jsx(LinkWrapper$1, {
      color: "shade.700",
      onClick: () => {
        var event = {
          event_name: 'Menu Element Clicked',
          category: EventCategory.NAVBAR,
          menuName: 'Kebab Menu',
          text: LABEL_DASHBOARD
        };
        analytics(event);
      },
      href: "".concat(path).concat(DASHBOARD_V2_PATH),
      "aria-label": LABEL_DASHBOARD,
      children: LABEL_DASHBOARD
    }), !isDomain && /*#__PURE__*/jsxs(LinkWrapper$1, {
      color: "shade.700",
      onClick: () => {
        var event = {
          event_name: 'Menu Element Clicked',
          category: EventCategory.NAVBAR,
          menuName: 'Kebab Menu',
          text: LABEL_PROPERTY_REPORT
        };
        analytics(event);
      },
      href: newPropertyReports ? "".concat(ROUTE_NEW_PROPERTY_REPORT) : "".concat(path).concat(ROUTE_PROPERTY_REPORT),
      target: "_blank",
      "aria-label": LABEL_PROPERTY_REPORT,
      children: [LABEL_PROPERTY_REPORT, /*#__PURE__*/jsx(LaunchIcon, {
        width: "18px",
        height: "18px"
      })]
    }), referAFriend && !isDomain && /*#__PURE__*/jsx(LinkWrapper$1, {
      color: "shade.700",
      onClick: () => {
        var event = {
          event_name: 'Menu Element Clicked',
          category: EventCategory.NAVBAR,
          menuName: 'Kebab Menu',
          text: LABEL_REFER_A_FRIEND
        };
        analytics(event);
      },
      href: "".concat(path).concat(ROUTE_REFER_A_FRIEND),
      "aria-label": LABEL_REFER_A_FRIEND,
      children: LABEL_REFER_A_FRIEND
    }), isLendi && sendFeedback && isSVA && /*#__PURE__*/jsx(LinkWrapper$1, {
      color: "shade.700",
      onClick: () => {
        var event = {
          event_name: 'Menu Element Clicked',
          category: EventCategory.NAVBAR,
          menuName: 'Kebab Menu',
          text: LABEL_SEND_FEEDBACK
        };
        sendFeedBackOnClick();
        analytics(event);
      },
      target: "_blank",
      "aria-label": LABEL_SEND_FEEDBACK,
      children: LABEL_SEND_FEEDBACK
    }), /*#__PURE__*/jsx(LinkWrapper$1, {
      color: "shade.700",
      onClick: () => {
        if (onLogout) onLogout();
        var event = {
          event_name: 'Menu Element Clicked',
          category: EventCategory.NAVBAR,
          menuName: 'Kebab Menu',
          text: LABEL_LOG_OUT
        };
        analytics(event);
      },
      "aria-label": LABEL_LOG_OUT,
      children: LABEL_LOG_OUT
    })]
  });
};

var KebabMenu = styled(IconButton).withConfig({
  displayName: "style__KebabMenu",
  componentId: "lui__sc-1kjveb6-0"
})(["", ""], ml('xxxs'));

var LogoutComponent = () => {
  var {
    isTransparent
  } = useNavbarBaseContext();
  var [isLogoutDisplay, setIsLogoutDisplay] = React.useState(false);
  var logoutPanel = React.useRef();
  var hasWindow = typeof window !== 'undefined';
  var theme = useTheme();
  var closeLogoutPanel = e => {
    if (logoutPanel && logoutPanel.current && !logoutPanel.current.contains(e.target)) {
      setIsLogoutDisplay(false);
    }
  };
  React.useEffect(() => {
    if (hasWindow) {
      window.addEventListener('mousedown', closeLogoutPanel);
    }
    return () => {
      if (hasWindow) {
        window.removeEventListener('mousedown', closeLogoutPanel);
      }
    };
  });
  return /*#__PURE__*/jsxs("div", {
    ref: logoutPanel,
    children: [/*#__PURE__*/jsx(KebabMenu, {
      size: "sm",
      color: isTransparent ? theme.color.interaction.subtle : theme.color.interaction.main,
      onClick: () => {
        setIsLogoutDisplay(!isLogoutDisplay);
        var event = {
          event_name: 'Menu Clicked',
          menuName: 'Kebab Menu',
          category: EventCategory.NAVBAR
        };
        analytics(event);
      },
      "aria-label": LABEL_MORE_OPTIONS,
      icon: MoreVert
    }), isLogoutDisplay && /*#__PURE__*/jsx(DropdownMenu, {})]
  });
};

var _templateObject$b;
var DesktopActionsWrapper = styled.div.withConfig({
  displayName: "style__DesktopActionsWrapper",
  componentId: "lui__sc-jh42qz-0"
})(["display:flex;", ";"], between('mobile', 'desktop')(_templateObject$b || (_templateObject$b = _taggedTemplateLiteral(["\n    display: none;\n  "]))));

var DEFAULT_DASHBOARD_URL = '/v2/dashboard/';
var getSignInURL = (brand, env, returnURL) => {
  var urls = getURLs(brand, Type.Customer, env);
  var dashboardReturnURL = brand === Brand$1.Domain ? "/loanfinder".concat(DEFAULT_DASHBOARD_URL) : DEFAULT_DASHBOARD_URL;
  // Confirmed with CMS team, all Lendi and Aussie landing pages will under /lp/ route.
  var lendiOrAussieLandingPageRoute = "".concat(urls.origin, "lp/");
  var hasNoReturnURL = returnURL === undefined || returnURL === '';
  var isReturnURLOrigin = returnURL === urls.origin;
  var isReturnURLLendiOrAussieLandingPage = (returnURL === null || returnURL === void 0 ? void 0 : returnURL.includes(lendiOrAussieLandingPageRoute)) && brand !== Brand$1.Domain;

  /**
   * The return URL should be based on origin
   * If origin is homepage, not given, or Lendi & Aussie marketing landing page, then return URL should be dashboard
   * else, whatever is given.
   */
  var newReturnURL = hasNoReturnURL || isReturnURLOrigin || isReturnURLLendiOrAussieLandingPage ? dashboardReturnURL : returnURL;
  return "".concat(urls.authenticate, "?returnURL=").concat(encodeURIComponent(newReturnURL));
};

var getEnvFromHostname = hostname => {
  if (hostname !== null && hostname !== void 0 && hostname.includes('dev.')) {
    return Environment.Development;
  } else if (hostname !== null && hostname !== void 0 && hostname.includes('stg.') || hostname !== null && hostname !== void 0 && hostname.includes('stage.')) {
    return Environment.Staging;
  } else if (hostname !== null && hostname !== void 0 && hostname.includes('preprod.')) {
    return Environment.Preproduction;
  } else if (hostname !== null && hostname !== void 0 && hostname.includes('lendi.com.au') || hostname !== null && hostname !== void 0 && hostname.includes('domain.com.au') || hostname !== null && hostname !== void 0 && hostname.includes('aussie.com.au')) {
    return Environment.Production;
  } else {
    return Environment.Development;
  }
};

var RenderChatOrSideBar = _ref => {
  var {
    openCommPanel = () => {},
    customerOwner,
    dashboardVariant,
    hasUnreadMessages
  } = _ref;
  var brand = getBrandFromHostname();
  var primaryLabel = customerOwner !== null && customerOwner !== void 0 && customerOwner.firstName ? "Talk to ".concat(customerOwner.firstName) : brand === 'aussie' ? LABEL_TALK_TO_A_BROKER : LABEL_TALK_TO_EXPERT;
  return /*#__PURE__*/jsx(TalkExpertAction, {
    dashboardVariant: dashboardVariant,
    size: "sm",
    variant: "secondary",
    onClick: () => {
      openCommPanel();
      var event = {
        event_name: 'Button Clicked',
        category: EventCategory.NAVBAR,
        buttonType: ButtonType.SECONDARY,
        text: hasUnreadMessages ? 'You have an unread message' : brand === 'aussie' ? 'Talk to a broker' : 'Talk to an expert'
      };
      analytics(event);
    },
    children: hasUnreadMessages ? /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(UnreadMessageWrapper, {
        "data-testid": "customer-view-unread-icon",
        color: getColour$1('interaction', 'main'),
        height: "2em",
        width: "2em"
      }), UNREAD_MESSAGE]
    }) : /*#__PURE__*/jsx(Fragment, {
      children: primaryLabel
    })
  });
};
var RenderDesktopAction = _ref2 => {
  var _window, _window2;
  var {
    dashboardVariant,
    isAuthenticated,
    continueURL,
    showContinueAction = false,
    showTalkToExpertCta = true,
    showBookanAppointmentCta = true,
    openCommPanel = () => {},
    customerOwner,
    hasUnreadMessages
  } = _ref2;
  var brand = getBrandFromHostname();
  var env = getEnvFromHostname((_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.hostname);
  var signInURL = getSignInURL(brand, env, (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.location) === null || _window2 === void 0 ? void 0 : _window2.href);
  var isDomain = brand === Brand.Domain;
  var path = isDomain ? PATH_DOMAIN : PATH_LENDI;
  var renderSecondaryBtn = (isAuthenticated, showBookanAppointmentCta, showContinueAction) => {
    return /*#__PURE__*/jsxs(Fragment, {
      children: [showContinueAction && isAuthenticated && /*#__PURE__*/jsx(SecondaryAction, {
        size: "sm",
        variant: 'emphasis',
        href: continueURL,
        onClick: () => {
          var event = {
            event_name: 'Button Clicked',
            buttonType: ButtonType.EMPHASIS,
            text: 'Continue',
            category: EventCategory.NAVBAR
          };
          analytics(event);
        },
        "aria-label": continueURL,
        children: LABEL_CONTINUE
      }), showContinueAction && !isAuthenticated && /*#__PURE__*/jsx(SecondaryAction, {
        size: "sm",
        variant: 'primary',
        href: signInURL,
        onClick: () => {
          var event = {
            event_name: 'Button Clicked',
            buttonType: ButtonType.PRIMARY,
            text: 'Sign In',
            category: EventCategory.NAVBAR
          };
          analytics(event);
        },
        "aria-label": signInURL,
        children: LABEL_SIGN_IN
      }), !showContinueAction && showBookanAppointmentCta && /*#__PURE__*/jsx(SecondaryAction, {
        size: "sm",
        variant: 'primary',
        href: "".concat(path).concat(ROUTE_BOOK_APPOINTMENT),
        onClick: () => {
          var event = {
            event_name: 'Button Clicked',
            buttonType: ButtonType.PRIMARY,
            text: 'Book an Appointment',
            category: EventCategory.NAVBAR
          };
          analytics(event);
        },
        "aria-label": "".concat(path).concat(ROUTE_BOOK_APPOINTMENT),
        children: BOOK_AN_APPOINTMENT
      })]
    });
  };
  return /*#__PURE__*/jsxs(DesktopActionsWrapper, {
    children: [showTalkToExpertCta && /*#__PURE__*/jsx(RenderChatOrSideBar, {
      openCommPanel: openCommPanel,
      customerOwner: customerOwner,
      dashboardVariant: dashboardVariant,
      hasUnreadMessages: hasUnreadMessages
    }), renderSecondaryBtn(isAuthenticated, showBookanAppointmentCta, showContinueAction), isAuthenticated && /*#__PURE__*/jsx(LogoutComponent, {})]
  });
};
var RenderDesktopAction$1 = RenderDesktopAction;

var _templateObject$a;
var MobileActionsWrapper = styled.div.withConfig({
  displayName: "style__MobileActionsWrapper",
  componentId: "lui__sc-jzhj4e-0"
})(["display:flex;", ";.noHover{", ";:hover{box-shadow:none;}}"], gte('desktop')(_templateObject$a || (_templateObject$a = _taggedTemplateLiteral(["\n    display: none;\n  "]))), mr('nil'));

var RenderMobileAction = _ref => {
  var _window, _window2;
  var {
    isAuthenticated,
    continueURL,
    customerOwner,
    openCommPanel = () => {},
    showContinueAction = false,
    showTalkToExpertCta = true,
    hasUnreadMessages
  } = _ref;
  var {
    isTransparent
  } = useNavbarBaseContext();
  var needToContinue = () => isAuthenticated && showContinueAction;
  var needToSignIn = () => !isAuthenticated && showContinueAction;
  var brand = getBrandFromHostname();
  var env = getEnvFromHostname((_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.hostname);
  var signInURL = getSignInURL(brand, env, (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.location) === null || _window2 === void 0 ? void 0 : _window2.href);
  var primaryLabel = customerOwner !== null && customerOwner !== void 0 && customerOwner.firstName ? "Talk to ".concat(customerOwner.firstName) : needToContinue() ? CONTACT_US : brand === 'aussie' ? LABEL_TALK_TO_A_BROKER : LABEL_TALK_TO_EXPERT;
  return /*#__PURE__*/jsxs(MobileActionsWrapper, {
    children: [showTalkToExpertCta && /*#__PURE__*/jsx(TalkExpertAction, {
      size: "sm",
      isInverse: isTransparent,
      className: "noHover",
      variant: "secondary",
      onClick: () => {
        openCommPanel();
        var event = {
          event_name: 'Button Clicked',
          category: EventCategory.NAVBAR,
          buttonType: ButtonType.SECONDARY,
          text: hasUnreadMessages ? 'You have an unread message' : brand === 'aussie' ? 'Talk to a broker' : 'Talk to an expert'
        };
        analytics(event);
      },
      children: hasUnreadMessages ? /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx(UnreadMessageWrapper, {
          "data-testid": "customer-view-unread-icon",
          color: getColour$1('interaction', 'main'),
          height: "2em",
          width: "2em"
        }), UNREAD_MESSAGE_MOBILE]
      }) : /*#__PURE__*/jsx(Fragment, {
        children: primaryLabel
      })
    }), needToSignIn() && /*#__PURE__*/jsx(SecondaryActionMobile, {
      size: "sm",
      variant: isAuthenticated ? 'emphasis' : 'primary',
      href: signInURL,
      onClick: () => {
        var event = {
          event_name: 'Button Clicked',
          buttonType: isAuthenticated ? ButtonType.EMPHASIS : ButtonType.PRIMARY,
          text: 'Sign In',
          category: EventCategory.NAVBAR
        };
        analytics(event);
      },
      "aria-label": signInURL,
      children: LABEL_SIGN_IN
    }), needToContinue() && /*#__PURE__*/jsx(ContinueAction, {
      variant: "emphasis",
      href: continueURL,
      "aria-label": LABEL_CONTINUE,
      size: "sm",
      onClick: () => {
        var event = {
          event_name: 'Button Clicked',
          category: EventCategory.NAVBAR,
          text: 'Continue',
          buttonType: ButtonType.EMPHASIS
        };
        analytics(event);
      },
      children: LABEL_CONTINUE
    }), isAuthenticated && /*#__PURE__*/jsx(LogoutComponent, {})]
  });
};
var RenderMobileAction$1 = RenderMobileAction;

var CTAButtons$2 = props => {
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(RenderDesktopAction$1, _objectSpread2({
      hasUnreadMessages: props.hasUnreadMessages
    }, props)), /*#__PURE__*/jsx(RenderMobileAction$1, _objectSpread2({
      hasUnreadMessages: props.hasUnreadMessages
    }, props))]
  });
};
var CTAButtons$3 = CTAButtons$2;

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}

var _excluded$a = ["showTalkToExpertCta"];
var withDomainChat = Component => _ref => {
  var {
      showTalkToExpertCta = true
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded$a);
  var session = useSession();
  var isAuthenticated = session.status === Status.Authenticated;
  var isDomain = getBrandFromHostname() === Brand.Domain;
  var isDomainUnauthenticated = isDomain && !isAuthenticated;
  var shouldShowChat = showTalkToExpertCta && !isDomainUnauthenticated;
  return /*#__PURE__*/jsx(Component, _objectSpread2(_objectSpread2({}, otherProps), {}, {
    showTalkToExpertCta: shouldShowChat
  }));
};

var DropdownProvider = _ref => {
  var {
    children,
    hideDashboardItem,
    hideManageApplicationsItem,
    onLogout
  } = _ref;
  return /*#__PURE__*/jsx(DropdownMenuContext.Provider, {
    value: {
      hideDashboardItem,
      hideManageApplicationsItem,
      onLogout
    },
    children: children
  });
};

var ErrorContext = /*#__PURE__*/React.createContext(undefined);
var useError = () => {
  var errorState = React.useContext(ErrorContext);
  if (!errorState) {
    throw new Error('Please setup <ErrorProvider /> as a parent component, before using useError().');
  }
  return errorState;
};

var ErrorProvider = _ref => {
  var {
    children,
    onException
  } = _ref;
  return /*#__PURE__*/jsx(ErrorContext.Provider, {
    value: {
      onException
    },
    children: children
  });
};

var withErrorProvider = Component => props => /*#__PURE__*/jsx(ErrorProvider, {
  onException: props.onException,
  children: /*#__PURE__*/jsx(Component, _objectSpread2({}, props))
});

var CommPanelWrapper$1 = styled.div.withConfig({
  displayName: "style__CommPanelWrapper",
  componentId: "lui__sc-no953w-0"
})(["", ";-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-rendering:optimizeLegibility;display:flex;flex-direction:column;height:100%;"], normalise);

var useDisableChat = () => {
  var [isChatDisabled, setIsChatDisabled] = useState(true);
  var {
    disableChat,
    enableAussieChat
  } = useFlags();
  var {
    brand
  } = useSession();
  useEffect(() => {
    if (brand === Brand.Aussie) {
      if (enableAussieChat !== undefined) setIsChatDisabled(!enableAussieChat);
    } else {
      if (disableChat !== undefined) setIsChatDisabled(disableChat);
    }
  }, [disableChat, enableAussieChat, brand]);
  return isChatDisabled;
};

var HeadWrapper = styled.div.withConfig({
  displayName: "style__HeadWrapper",
  componentId: "lui__sc-zy0mzz-0"
})(["border-bottom:1px solid ", ";", ";"], color('shade.100'), mt('xxl'));
var BrokerWrapper = styled.div.withConfig({
  displayName: "style__BrokerWrapper",
  componentId: "lui__sc-zy0mzz-1"
})(["display:flex;align-items:center;", ";"], ml('xl'));
var BrokerImgWrapper = styled.div.withConfig({
  displayName: "style__BrokerImgWrapper",
  componentId: "lui__sc-zy0mzz-2"
})(["", ";position:relative;"], mr('xs'));
var BrokerFace$1 = styled.img.withConfig({
  displayName: "style__BrokerFace",
  componentId: "lui__sc-zy0mzz-3"
})(["width:65px;height:65px;border-radius:50%;border:1px solid ", ";margin:auto;"], color('shade.100'));
var BrokerDetail = styled.div.withConfig({
  displayName: "style__BrokerDetail",
  componentId: "lui__sc-zy0mzz-4"
})(["display:flex;flex-direction:column;justify-content:space-between;", ";"], ml('xxs'));
var BrokerName = styled(Heading).withConfig({
  displayName: "style__BrokerName",
  componentId: "lui__sc-zy0mzz-5"
})(["font-weight:bold;"]);
var StyledFace$1 = styled(Face).withConfig({
  displayName: "style__StyledFace",
  componentId: "lui__sc-zy0mzz-6"
})(["width:4.5em;height:4.5em;"]);
var StatusIcon$1 = styled.div.withConfig({
  displayName: "style__StatusIcon",
  componentId: "lui__sc-zy0mzz-7"
})(["width:17px;height:17px;border-radius:50%;position:absolute;right:1px;bottom:8px;", ";"], props => props.isOnline ? bg('success.600') : bg('shade.400'));
var StyledBrokerFaces = styled.img.withConfig({
  displayName: "style__StyledBrokerFaces",
  componentId: "lui__sc-zy0mzz-8"
})(["width:191px;display:block;margin-left:56px;"]);
var StyledBody = styled(Body).withConfig({
  displayName: "style__StyledBody",
  componentId: "lui__sc-zy0mzz-9"
})(["margin-top:4px;"]);

var IMAGE_CDN = 'https://lendicdn.net/327bd43fb6e1de7a0a3f44af5ad14156/71ccb7a35a452ea8153b6d920f9f190e'; // This is the production CDN link for Shaka Storybook, which hosts static images

var mapProfileToTitle = profile => {
  switch (profile) {
    case 'Associate':
      return 'Home Loan Associate';
    case 'Broker':
      return 'Home Loan Specialist';
    case 'Broker Manager':
      return 'Home Loan Specialist';
    case 'Customer Solutions':
      return 'Customer Solutions';
    case 'Offboarded User':
      return 'Home Loan Specialist';
    case 'Partner Broker':
      return 'Home Loan Consultant';
    case 'Relationship Manager':
      return 'Relationship Manager';
    case 'Senior Relationship Manager':
      return 'Relationship Manager';
  }
};
var TeamMemberInfo = /*#__PURE__*/React.memo(_ref => {
  var {
    teamMember,
    isOtherUserOnline
  } = _ref;
  var {
    brand
  } = useSession();
  return /*#__PURE__*/jsxs(HeadWrapper, {
    children: [/*#__PURE__*/jsx(BrokerWrapper, {
      children: teamMember ? /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsxs(BrokerImgWrapper, {
          children: [teamMember.profilePictureURL ? /*#__PURE__*/jsx(BrokerFace$1, {
            src: teamMember.profilePictureURL
          }) : /*#__PURE__*/jsx(StyledFace$1, {}), /*#__PURE__*/jsx(StatusIcon$1, {
            isOnline: isOtherUserOnline,
            "aria-label": isOtherUserOnline ? 'Online' : 'Offline'
          })]
        }), /*#__PURE__*/jsxs(BrokerDetail, {
          children: [/*#__PURE__*/jsx(BrokerName, {
            size: "sm",
            color: "shade.700",
            children: teamMember.firstName
          }), /*#__PURE__*/jsx(BrokerName, {
            size: "sm",
            color: "shade.700",
            children: teamMember.lastName
          }), /*#__PURE__*/jsx(StyledBody, {
            size: "xs",
            color: "shade.400",
            mb: "xs",
            children: mapProfileToTitle(teamMember.profile) || 'Home Loan Specialist'
          })]
        })]
      }) : /*#__PURE__*/jsx(StyledBrokerFaces, {
        src: "".concat(IMAGE_CDN, "/images/").concat(brand, ".png"),
        alt: "Friendly broker image"
      })
    }), /*#__PURE__*/jsx(Body, {
      size: "md",
      align: "center",
      mx: "lg",
      color: "shade.700",
      mb: "sm",
      mt: "sm",
      children: teamMember ? "I'm here to support your loan journey. Got a question? Just ask!" : "Get in touch with one of our ".concat(brand === 'aussie' ? 'brokers' : 'experts', " who can answer all your home loan related questions.")
    })]
  });
});

// LUI-465 we are hard-coding theming for this component as not all colours are part of our semantic palette
var theming = {
  lendi: {
    background: '#E6EEF0',
    foreground: '#0D5A6D'
  },
  domain: {
    background: '#E6E8EC',
    foreground: '#06193A'
  },
  aussie: {
    background: '#EEEAF1',
    foreground: '#522B6F'
  }
};
var getThemedColour = property => {
  var theTheme = getThemeName();
  var theme = theTheme === 'lendi-next' ? theming.lendi : theming[theTheme];
  return theme[property];
};

var ULOptions = styled.ul.withConfig({
  displayName: "style__ULOptions",
  componentId: "lui__sc-absiyo-0"
})(["list-style-type:none;width:100%;", " ", " ", ";"], m('nil'), p('nil'), pb('xxs'));
var selectedStyle = css(["background-color:", ";p{", ";}svg{fill:", ";}"], () => getThemedColour('background'), fg('shade.0'), color('shade.0'));
var ItemWrapper = styled.li.withConfig({
  displayName: "style__ItemWrapper",
  componentId: "lui__sc-absiyo-1"
})(["list-style-type:none;width:100%;border-bottom:1px solid ", ";:focus,:hover,:visited{text-decoration:none;}:hover{", "}"], color('shade.100'), selectedStyle);
var LinkWrapper = styled(Link).withConfig({
  displayName: "style__LinkWrapper",
  componentId: "lui__sc-absiyo-2"
})(["color:", ";width:100%;display:flex;align-items:center;text-decoration:none;font-weight:600;:focus,:hover{background-color:", ";color:", ";text-decoration:none;}padding-left:20px;", ";"], () => getThemedColour('foreground'), () => getColour('fill', 'contrast'), () => getColour('text', 'inverse'), py('xs'));
var BodyWrapper = styled(Body).withConfig({
  displayName: "style__BodyWrapper",
  componentId: "lui__sc-absiyo-3"
})(["", ";color:", ";font-family:", ";font-size:16px;font-weight:bold;"], pl('sm'), () => getColour('interaction', 'secondary'), getTypography('body1', 'fontFamily'));
var ChatBodyWrapper = styled.div.withConfig({
  displayName: "style__ChatBodyWrapper",
  componentId: "lui__sc-absiyo-4"
})(["display:flex;justify-content:space-between;align-items:center;", ";"], pr('md'));

var CONTACT_NUMBERS = {
  lendi: '1300 323 181',
  domain: '1300 525 454',
  aussie: '13 13 33'
};
var BOOKING_PATHS = {
  lendi: '',
  domain: '/loanfinder',
  aussie: ''
};
var toTel = phoneNumber => "tel:+61".concat(phoneNumber.replace(/ /g, ''));
var PanelLinks = _ref => {
  var _teamMember$phoneNumb;
  var {
    teamMember,
    store,
    broker
  } = _ref;
  var {
    enhancedPrl
  } = useFlags();
  var {
    name
  } = useTheme();
  var currentTheme = name;
  if (currentTheme === 'lendi-next') currentTheme = 'lendi';
  var path = BOOKING_PATHS[currentTheme];
  var phoneLabel = (_teamMember$phoneNumb = teamMember === null || teamMember === void 0 ? void 0 : teamMember.phoneNumber) !== null && _teamMember$phoneNumb !== void 0 ? _teamMember$phoneNumb : CONTACT_NUMBERS[currentTheme];
  var phoneLink = teamMember !== null && teamMember !== void 0 && teamMember.phoneNumber ? toTel(teamMember.phoneNumber) : "tel:".concat(phoneLabel.replace(/ /g, ''));
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(ItemWrapper, {
      children: /*#__PURE__*/jsxs(LinkWrapper, {
        href: phoneLink,
        "aria-label": "contact us by phone",
        "data-testid": "customer-view-phone-link",
        "data-component": "customer-view-phone-link",
        onClick: () => {
          var levent = {
            event_name: 'Link Clicked',
            text: phoneLabel,
            category: EventCategory.COMMSPANEL,
            linkType: 'link',
            position: 'Contact Us',
            customerType: CustomerType.CUSTOMER
          };
          analytics(levent);
        },
        children: [/*#__PURE__*/jsx(Phone, {
          "data-testid": "customer-view-phone-icon",
          height: "18px",
          width: "18px"
        }), /*#__PURE__*/jsx(BodyWrapper, {
          size: "md",
          children: phoneLabel
        })]
      })
    }), /*#__PURE__*/jsx(ItemWrapper, {
      children: /*#__PURE__*/jsxs(LinkWrapper, {
        href: "".concat(path, "/book-appointment/"),
        "aria-label": "book an appointment",
        "data-testid": "customer-view-appointment-link",
        "data-component": "customer-view-appointment-link",
        onClick: () => {
          // Set Leads if customer clicked on BookApointment from Store page.
          // Unset Leads (to undefined) if customer clicked on BookApointment from non-Store page.
          // Set and Unset Leads if customer clicked on BookApointment from Broker page.
          // Unset Leads (to undefined) if customer clicked on BookApointment from non-Broker page.
          if (!enhancedPrl) {
            store !== null && store !== void 0 && store.id ? LendiGroupLeads.setStoreId(store === null || store === void 0 ? void 0 : store.id) : LendiGroupLeads.unsetStoreId();
            broker !== null && broker !== void 0 && broker.id ? LendiGroupLeads.setBrokerId(broker === null || broker === void 0 ? void 0 : broker.id) : LendiGroupLeads.unsetBrokerId();
          } else {
            store !== null && store !== void 0 && store.id ? sessionStorage.setItem(SESSION_STORAGE_KEYS.CTOR_TARGET_STORE_ID, store === null || store === void 0 ? void 0 : store.id) : sessionStorage.removeItem(SESSION_STORAGE_KEYS.CTOR_TARGET_STORE_ID);
            broker !== null && broker !== void 0 && broker.id ? sessionStorage.setItem(SESSION_STORAGE_KEYS.CTOR_TARGET_BROKER_ID, broker === null || broker === void 0 ? void 0 : broker.id) : sessionStorage.removeItem(SESSION_STORAGE_KEYS.CTOR_TARGET_BROKER_ID);
          }
          // Analytics
          var linkEvent = {
            event_name: 'Link Clicked',
            text: 'Book an appointment',
            category: EventCategory.COMMSPANEL,
            linkType: 'link',
            customerType: CustomerType.CUSTOMER
          };
          analytics(linkEvent);
        },
        children: [/*#__PURE__*/jsx(Calendar, {
          "data-testid": "customer-view-calendar-icon",
          height: "18px",
          width: "18px"
        }), /*#__PURE__*/jsx(BodyWrapper, {
          size: "md",
          children: "Book an appointment"
        })]
      })
    })]
  });
};

var UnReadDot = styled.div.withConfig({
  displayName: "style__UnReadDot",
  componentId: "lui__sc-10i6qtc-0"
})(["width:7px;height:7px;border-radius:50%;position:absolute;right:-2px;top:-2px;", ";"], bg('error.600'));
var StyledChatIcon = styled.span.withConfig({
  displayName: "style__StyledChatIcon",
  componentId: "lui__sc-10i6qtc-1"
})(["position:relative;"]);

var ChatIcon = _ref => {
  var {
    hasNew
  } = _ref;
  return /*#__PURE__*/jsxs(StyledChatIcon, {
    children: [/*#__PURE__*/jsx(Chat, {
      color: getColour$1('interaction', 'secondary'),
      height: "18px",
      width: "18px"
    }), hasNew ? /*#__PURE__*/jsx(UnReadDot, {}) : /*#__PURE__*/jsx(Fragment, {})]
  });
};

var ChatLinKWrapper = styled(ItemWrapper).withConfig({
  displayName: "style__ChatLinKWrapper",
  componentId: "lui__sc-1pa95jd-0"
})(["", ";", ";"], _ref => {
  var {
    disabled
  } = _ref;
  return disabled && css(["pointer-events:none;opacity:0.6;"]);
}, _ref2 => {
  var {
    isChatOpen
  } = _ref2;
  return isChatOpen && css(["background-color:", ";p{color:", ";}svg{fill:", ";}"], getColour('fill', 'contrast'), getColour('interaction', 'subtle'), getColour('interaction', 'subtle'));
});
var positionedRight = css(["position:absolute;right:10px;"]);
styled(KeyboardArrowDown).withConfig({
  displayName: "style__ChevronUpDownIcon",
  componentId: "lui__sc-1pa95jd-1"
})(["", ";", ""], positionedRight, _ref3 => {
  var {
    isChatOpen
  } = _ref3;
  return css(["transition:transform 0.25s;transform:rotate(", ");"], isChatOpen ? '180deg' : '0deg');
});
var ChevronRightIcon = styled(KeyboardArrowRight).withConfig({
  displayName: "style__ChevronRightIcon",
  componentId: "lui__sc-1pa95jd-2"
})([""]);
var StyledChevronRightIcon = styled(ChevronRightIcon).withConfig({
  displayName: "style__StyledChevronRightIcon",
  componentId: "lui__sc-1pa95jd-3"
})(["", ";"], positionedRight);

var ChatLink = _ref => {
  var {
    disabled,
    onChatLinkClick,
    hasNew,
    isChatOpen
  } = _ref;
  return /*#__PURE__*/jsx(ChatLinKWrapper, {
    disabled: disabled,
    isChatOpen: isChatOpen,
    children: /*#__PURE__*/jsxs(LinkWrapper, {
      onClick: onChatLinkClick,
      "aria-label": "Chat Online",
      children: [/*#__PURE__*/jsx(ChatIcon, {
        hasNew: hasNew
      }), /*#__PURE__*/jsxs(ChatBodyWrapper, {
        children: [/*#__PURE__*/jsx(BodyWrapper, {
          size: "md",
          children: "Chat Now"
        }), /*#__PURE__*/jsx(StyledChevronRightIcon, {
          color: getColour$1('interaction', 'main'),
          height: "24px",
          width: "24px"
        })]
      })]
    })
  });
};

var SidePanel = _ref => {
  var {
    teamMember,
    broker,
    store,
    hasChat,
    isChatOpen,
    onChatLinkClick,
    disabled,
    isOtherUserOnline,
    hasNew
  } = _ref;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(TeamMemberInfo, {
      teamMember: teamMember,
      isOtherUserOnline: isOtherUserOnline
    }), /*#__PURE__*/jsxs(ULOptions, {
      children: [/*#__PURE__*/jsx(PanelLinks, {
        teamMember: teamMember,
        broker: broker,
        store: store
      }), hasChat && /*#__PURE__*/jsx(ChatLink, {
        isChatOpen: isChatOpen,
        disabled: disabled,
        onChatLinkClick: onChatLinkClick,
        hasNew: hasNew
      })]
    })]
  });
};

styled.div.withConfig({
  displayName: "style__MobileBrokerInfoWrapper",
  componentId: "lui__sc-18wuygo-0"
})(["display:flex;align-items:center;"]);
var FaceWrapper = styled.span.withConfig({
  displayName: "style__FaceWrapper",
  componentId: "lui__sc-18wuygo-1"
})(["position:relative;"]);
var BrokerFace = styled.img.withConfig({
  displayName: "style__BrokerFace",
  componentId: "lui__sc-18wuygo-2"
})(["width:20px;height:20px;border-radius:50%;border:1px solid ", ";"], color('shade.100'));
var StatusIcon = styled.span.withConfig({
  displayName: "style__StatusIcon",
  componentId: "lui__sc-18wuygo-3"
})(["width:8px;height:8px;border-radius:50%;position:absolute;right:-1px;bottom:4px;", ";"], props => props.isOnline ? bg('success.600') : bg('shade.400'));
var StyledFace = styled(Face).withConfig({
  displayName: "style__StyledFace",
  componentId: "lui__sc-18wuygo-4"
})(["height:26px;width:22px;"]);

var ChatHeaderTeamMemberAvatar = _ref => {
  var {
    teamMember,
    isBrokerOnline
  } = _ref;
  return /*#__PURE__*/jsxs(FaceWrapper, {
    children: [teamMember !== null && teamMember !== void 0 && teamMember.profilePictureURL ? /*#__PURE__*/jsx(BrokerFace, {
      src: teamMember.profilePictureURL
    }) : /*#__PURE__*/jsx(StyledFace, {}), /*#__PURE__*/jsx(StatusIcon, {
      isOnline: isBrokerOnline,
      "aria-label": isBrokerOnline ? 'Online' : 'Offline'
    })]
  });
};

var StickyHeader = styled.div.withConfig({
  displayName: "style__StickyHeader",
  componentId: "lui__sc-1pqeqpe-0"
})(["top:0;position:relative;display:flex;flex-direction:row;z-index:3;width:100%;background-color:", ";align-items:center;padding-left:10px;", " ", "   border-bottom:1px solid ", ";cursor:pointer;"], getColour('interaction', 'subtle'), pt('xs'), pb('xxs'), getColour('background', 'surface'));
var TeamMemberBodyWrapper = styled(Body).withConfig({
  displayName: "style__TeamMemberBodyWrapper",
  componentId: "lui__sc-1pqeqpe-1"
})(["", ";font-size:16px;font-weight:bold;"], pl('xxs'));
var ChevronLeftIcon = styled(KeyboardArrowLeft).withConfig({
  displayName: "style__ChevronLeftIcon",
  componentId: "lui__sc-1pqeqpe-2"
})([""]);

var FullViewChatHeader = _ref => {
  var {
    onClick,
    teamMember,
    isOtherUserOnline
  } = _ref;
  return /*#__PURE__*/jsx(StickyHeader, {
    onClick: onClick,
    children: /*#__PURE__*/jsx(Fragment, {
      children: teamMember ? /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx(ChevronLeftIcon, {
          color: getColour$1('interaction', 'secondary'),
          height: "24px",
          width: "24px"
        }), /*#__PURE__*/jsx(ChatHeaderTeamMemberAvatar, {
          teamMember: teamMember,
          isBrokerOnline: isOtherUserOnline
        }), /*#__PURE__*/jsx(ChatBodyWrapper, {
          children: /*#__PURE__*/jsx(TeamMemberBodyWrapper, {
            size: "md",
            color: "secondary.500",
            children: teamMember ? "".concat(teamMember.firstName, " ").concat(teamMember.lastName) : 'Home Loan Specialist'
          })
        })]
      }) : /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx(KeyboardArrowLeft, {
          color: getColour$1('interaction', 'secondary'),
          height: "24px",
          width: "24px"
        }), /*#__PURE__*/jsx(BodyWrapper, {
          size: "md",
          children: "Chat online"
        })]
      })
    })
  });
};

var StyledClose = styled(IconButton).withConfig({
  displayName: "style__StyledClose",
  componentId: "lui__sc-qeih4b-0"
})(["position:absolute;"]);

var WithChatView = _ref => {
  var {
    legacySupport,
    userType,
    isOtherUserOnline,
    hasNew,
    onException
  } = _ref;
  var {
    closeCommPanel,
    isCommPanelOpen,
    isChatOpen,
    openChat,
    teamMember,
    broker,
    store,
    channelId,
    migratedToConversation,
    setSelectedThread,
    applicationId,
    closeChat
  } = useBootstrappedChatState();
  var hasChat = !useDisableChat();
  var {
    enableHistoricalThreads
  } = useFlags();
  return /*#__PURE__*/jsxs(Fragment, {
    children: [(isCommPanelOpen && !isChatOpen || !enableHistoricalThreads) && /*#__PURE__*/jsx(StyledClose, {
      color: "shade.300",
      onClick: closeCommPanel,
      size: "md",
      "aria-label": "Close comm panel",
      icon: Close
    }), isChatOpen && !enableHistoricalThreads && /*#__PURE__*/jsx(FullViewChatHeader, {
      teamMember: teamMember,
      isOtherUserOnline: isOtherUserOnline,
      onClick: closeChat
    }), !isChatOpen && /*#__PURE__*/jsx(SidePanel, {
      teamMember: teamMember,
      store: store,
      broker: broker,
      hasChat: hasChat,
      isChatOpen: isChatOpen,
      disabled: false,
      onChatLinkClick: openChat,
      isOtherUserOnline: isOtherUserOnline,
      hasNew: hasNew
    }), hasChat && /*#__PURE__*/jsx(Chat$1, {
      openChat: isChatOpen,
      userType: userType,
      teamMember: teamMember,
      channelId: channelId,
      migratedToConversation: migratedToConversation,
      onException: onException,
      setSelectedThread: setSelectedThread,
      applicationId: applicationId
    })]
  });
};

var CustomerCommPanel = _ref => {
  var {
    legacySupport = false,
    isOtherUserOnline = false,
    hasNew,
    onException
  } = _ref;
  return /*#__PURE__*/jsx(CommPanelWrapper$1, {
    children: /*#__PURE__*/jsx(WithChatView, {
      legacySupport: legacySupport,
      userType: 'customer',
      isOtherUserOnline: isOtherUserOnline,
      hasNew: hasNew,
      onException: onException
    })
  });
};

var _excluded$9 = ["children", "className", "isOpen", "handleClose", "topOffset"];
var _templateObject$9, _templateObject2$4;
var IS_OPEN_DATA_ATTRIBUTE = 'data-slideout-isOpen';
var slideInRight = keyframes(["0%{transform:translate3d(100%,0,0);}100%{transform:translate3d(0,0,0);}"]);
var slideOutRight = keyframes(["0%{transform:translate3d(0,0,0);}100%{transform:translate3d(100%,0,0);}"]);

/**
 * @todo z-index: tokenise z-index to make it easier to manage levels
 */

var StyledSlideoutMenu$1 = styled.div.withConfig({
  displayName: "SlideoutMenuBase__StyledSlideoutMenu",
  componentId: "lui__sc-msuqad-0"
})(["display:none;width:100%;position:fixed;top:0;bottom:0;right:0;z-index:2;animation-fill-mode:forwards;animation-duration:0.3s;animation-timing-function:ease;", " &.is-open{transform:translate3d(0,0,0);display:block;}&.slide-in-right{animation-name:", ";}&.slide-out-right{animation-name:", ";}", ""], gte('sm')(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral(["\n    width: ", ";;\n  "])), pxToRem(375)), slideInRight, slideOutRight, _ref => {
  var {
    topOffset
  } = _ref;
  return topOffset && map(topOffset, value => value && "top: ".concat(value));
});

// Sorry, 'any' typing hack to get rid of 'not a valid JSX element' warning when using in component return block
// @todo this is also an issue in the Theme component with global styles
// https://github.com/styled-components/styled-components/issues/3738
var BodyStyles = createGlobalStyle(["", ""], _ref2 => {
  var {
    isOpen
  } = _ref2;
  return isOpen && css(["[data-slideout-isOpen]{", "}"], between('xs', 'sm')(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteral(["\n      overflow: hidden;  \n    "]))));
});
var useSlideoutMenu = () => {
  var [showMenu, setShowMenu] = useState(false);
  var toggleMenu = () => setShowMenu(!showMenu);
  return {
    showMenu,
    toggleMenu
  };
};
var SlideoutMenuBase = _ref3 => {
  var {
      children,
      className,
      isOpen,
      handleClose,
      topOffset
    } = _ref3,
    props = _objectWithoutProperties(_ref3, _excluded$9);
  var globalProps = filterGlobalProps(props);
  var slideoutRef = useRef(null);
  var animationClassnames = isOpen ? "is-open slide-in-right" : 'slide-out-right';
  var classNames = className ? "".concat(className, " ").concat(animationClassnames) : animationClassnames;

  // If the item is open listen for escape key
  useEffect(() => {
    var escapeEvent = event => {
      if (event.key === 'Escape') {
        // if there are multiple menus open, make sure we only close the one that is currently focused
        if (slideoutRef.current !== null && slideoutRef !== null && slideoutRef !== void 0 && slideoutRef.current.contains(document.activeElement)) {
          handleClose();
        }
      }
    };
    if (isOpen) {
      window.addEventListener('keydown', escapeEvent);
      if (slideoutRef !== null && slideoutRef !== void 0 && slideoutRef.current) slideoutRef.current.style.display = 'block';
    }
    return () => {
      window.removeEventListener('keydown', escapeEvent);
    };
  }, [isOpen]); // eslint-disable-line react-hooks/exhaustive-deps

  // Add data attribute to body as hook for indicating a slideout menu is open
  useEffect(() => {
    var allMenus = document.querySelectorAll('[data-is-open]');
    var atLeastOneIsOpen = Array.from(allMenus).some(item => item.getAttribute('data-is-open') === 'true');
    if (isOpen) {
      document.body.setAttribute(IS_OPEN_DATA_ATTRIBUTE, '');
    } else {
      // If multiple menus are open, we only want to remove the open attribute when they are all closed
      if (!atLeastOneIsOpen) {
        document.body.removeAttribute(IS_OPEN_DATA_ATTRIBUTE);
      }
    }
  }, [isOpen]); // eslint-disable-line react-hooks/exhaustive-deps

  var onAnimationEnd = () => {
    if (!isOpen) {
      var _slideoutRef$current;
      // happens after close
      slideoutRef === null || slideoutRef === void 0 || (_slideoutRef$current = slideoutRef.current) === null || _slideoutRef$current === void 0 || (_slideoutRef$current = _slideoutRef$current.classList) === null || _slideoutRef$current === void 0 || _slideoutRef$current.remove("slide-out-right");
      if (slideoutRef !== null && slideoutRef !== void 0 && slideoutRef.current) slideoutRef.current.style.display = 'none';
    } else {
      var _slideoutRef$current2;
      // happens after open
      slideoutRef === null || slideoutRef === void 0 || (_slideoutRef$current2 = slideoutRef.current) === null || _slideoutRef$current2 === void 0 || _slideoutRef$current2.classList.remove("slide-in-right");
    }
  };
  return /*#__PURE__*/jsxs(FocusLock, {
    disabled: !isOpen,
    returnFocus: true,
    children: [/*#__PURE__*/jsx(BodyStyles, {
      isOpen: isOpen
    }), /*#__PURE__*/jsx(StyledSlideoutMenu$1, _objectSpread2(_objectSpread2({
      className: classNames,
      topOffset: topOffset
    }, globalProps), {}, {
      onAnimationEnd: onAnimationEnd,
      ref: slideoutRef,
      "data-is-open": isOpen,
      children: children
    }))]
  });
};

var _templateObject$8, _templateObject2$3;
var StyledWrapper = styled.div.withConfig({
  displayName: "style__StyledWrapper",
  componentId: "lui__sc-1hl3v3a-0"
})(["", ";right:14px;position:fixed;bottom:30px;padding:14px;align-items:center;gap:10px;border-radius:40px;color:#fff;background-color:#e52c64;cursor:pointer;box-shadow:0px 0px 2px 0px rgba(0,0,0,0.12),0px 2px 2px 0px rgba(0,0,0,0.12),0px 1px 3px 0px rgba(0,0,0,0.14);transition:width 600ms ease-in-out;width:", ";&:hover{width:143px;}"], gte('tablet')(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral(["\n  right: 16px;\n  "]))), _ref => {
  var {
    isContracted
  } = _ref;
  return isContracted ? '50px' : '143px';
});
var BubbleBody = styled.div.withConfig({
  displayName: "style__BubbleBody",
  componentId: "lui__sc-1hl3v3a-1"
})(["display:flex;flex-direction:row;gap:10px;align-items:center;position:relative;"]);
var Label$1 = styled.span.withConfig({
  displayName: "style__Label",
  componentId: "lui__sc-1hl3v3a-2"
})(["", ";color:#fff;text-align:center;font-size:12px;font-style:normal;font-weight:700;line-height:20px;&.hidden{display:none;}"], gte('tablet')(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  "]))));
var Dot = styled.span.withConfig({
  displayName: "style__Dot",
  componentId: "lui__sc-1hl3v3a-3"
})(["width:24px;height:24px;border-radius:40px;background-color:", ";position:absolute;top:-21px;right:-19px;"], getColour$1('interaction', 'main'));

var ChatBubble = _ref => {
  var {
    onClick: _onClick
  } = _ref;
  var [isContracted, setContracted] = useState(false);
  var [showLabel, setShowLabel] = useState(true);
  useEffect(() => {
    var timeout = setTimeout(() => {
      setContracted(true);
      setShowLabel(false);
    }, 2000);
    return () => clearTimeout(timeout);
  }, []);
  useEffect(() => {
    var timeout;
    if (isContracted) {
      setShowLabel(false);
    } else {
      timeout = setTimeout(() => {
        setShowLabel(true);
      }, 650);
    }
    return () => clearTimeout(timeout);
  }, [isContracted, showLabel]);
  return /*#__PURE__*/jsx(StyledWrapper, {
    isContracted: isContracted,
    onClick: () => {
      _onClick();
      var bubbleEvent = {
        event_name: 'Chat Bubble Opened',
        category: EventCategory.NAVBAR,
        text: 'Chat online',
        customerType: CustomerType.CUSTOMER
      };
      analytics(bubbleEvent);
    },
    onMouseEnter: () => setContracted(false),
    onMouseLeave: () => setContracted(true),
    children: /*#__PURE__*/jsxs(BubbleBody, {
      children: [/*#__PURE__*/jsx(Chat, {
        width: "24px",
        height: "24px"
      }), showLabel && /*#__PURE__*/jsx(Label$1, {
        children: "Chat online"
      }), /*#__PURE__*/jsx(Dot, {})]
    })
  });
};
var ChatBubble$1 = ChatBubble;

var _templateObject$7;
var CommPanelWrapper = styled(SlideoutMenuBase).withConfig({
  displayName: "CommPanelProvider__CommPanelWrapper",
  componentId: "lui__sc-jqofne-0"
})(["max-width:", ";background-color:", ";box-shadow:0px 4px 4px 0px ", ";", " ", ";"], pxToRem(375), getColour('shade', 0), getColour('shade', 200), _ref => {
  var {
    topOffset,
    toTheTop
  } = _ref;
  if (!toTheTop) {
    if (topOffset) {
      return map(topOffset, value => value && "top: ".concat(value, ";"));
    } else {
      return css(["top:", ";", ";"], navTokens.size.height.navbar.mobile.value, gte('desktop')(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral(["\n            top: ", ";\n          "])), navTokens.size.height.navbar.desktop.value));
    }
  }
}, _ref2 => {
  var {
    toTheTop
  } = _ref2;
  return toTheTop && css(["top:0;z-index:999;"]);
});
var withCommPanelWrapper = Component =>
// eslint-disable-next-line react/display-name
props => {
  var {
    onException
  } = useError();
  var {
    chatBubble,
    chatExperiment
  } = useFlags();
  var {
    isCommPanelOpen,
    openCommPanel,
    closeCommPanel,
    channelId,
    customerOwner,
    openChat
  } = useBootstrappedChatState();
  var [hasUnread, setHasUnread] = React.useState(false);
  var [isOtherUserOnline, setIsOtherUserOnline] = React.useState(false);
  var [breakpoint, setBreakpoint] = React.useState();
  var [renderChatBubble, setRenderChatBubble] = useState(false);
  useBreakpoint(setBreakpoint);
  var theme = getThemeName();
  var shouldFullScreen = theme === 'aussie' || breakpoint === 'mobile';
  var isExperiment = chatExperiment === 'Experiment1' || chatExperiment === 'Experiment3';
  useEffect(() => {
    var timeout;
    if (props.enableChatBubble && chatBubble && isExperiment) {
      setRenderChatBubble(true);
    }
    return () => clearTimeout(timeout);
  }, [props, chatBubble, isExperiment]);
  return /*#__PURE__*/jsxs(ChatDataExposureContext.Provider, {
    value: {
      setHasUnReadMessage: hasUnreadMessages => setHasUnread(hasUnreadMessages),
      setStatus: status => setIsOtherUserOnline(status)
    },
    children: [/*#__PURE__*/jsx(Component, _objectSpread2(_objectSpread2({}, props), {}, {
      isCommPanelOpen: isCommPanelOpen,
      hasUnread: hasUnread,
      closeCommPanel: closeCommPanel,
      openCommPanel: openCommPanel,
      customerOwner: customerOwner
    })), /*#__PURE__*/jsx(CommPanelWrapper, _objectSpread2(_objectSpread2({
      isOpen: isCommPanelOpen,
      handleClose: closeCommPanel,
      toTheTop: shouldFullScreen,
      topOffset: props === null || props === void 0 ? void 0 : props.topOffset
    }, props), {}, {
      children: /*#__PURE__*/jsx(CustomerCommPanel, {
        channelId: channelId,
        hasNew: hasUnread,
        isOtherUserOnline: isOtherUserOnline,
        onException: onException
      })
    })), props.enableChatBubble && renderChatBubble && /*#__PURE__*/jsx(ChatBubble$1, {
      onClick: openChat
    })]
  });
};
var withCommPanel = Component => withCustomerChatProvider(withCommPanelWrapper(Component));

var setLenderIdInSessionStorage = id => {
  if (!id) return;
  sessionStorage.setItem('AHL', id);
};
var unsetLenderIdInSessionStorage = () => {
  sessionStorage.removeItem('AHL');
};
var useAHLParam = () => {
  useEffect(() => {
    if (typeof window !== undefined && window.sessionStorage) {
      var url = window.location.pathname;
      if (url.match(CMS_AHL_MAIN_URL_MATCH) || url.match(CMS_AHL_ELEVATE_URL_MATCH)) {
        return setLenderIdInSessionStorage(AHLProducts.AUSSIE_ELEVATE);
      }
      if (url.match(CMS_AHL_ACTIVATE_URL_MATCH)) {
        return setLenderIdInSessionStorage(AHLProducts.AUSSIE_ACTIVATE);
      }
      if (url.match(CMS_AHL_SELECT_URL_MATCH)) {
        return setLenderIdInSessionStorage(AHLProducts.AUSSIE_SELECT);
      }
      if (!url.match(FUNNEL1_URL_MATCH)) {
        return unsetLenderIdInSessionStorage();
      }
    }
  }, []);
};

var SimpleNavbarComponent = _ref => {
  var {
    // Public props
    useTransparent = false,
    showBookanAppointmentCta = true,
    showTalkToExpertCta = true,
    homeURL,
    params = '',
    continueURL = '/',
    onLogout,
    showContinueAction = false,
    hideDashboardItem,
    hideManageApplicationsItem,
    // Internal props, from ChatProps
    isCommPanelOpen,
    hasUnread,
    closeCommPanel,
    openCommPanel: _openCommPanel,
    customerOwner
  } = _ref;
  var session = useSession();
  var isAuthenticated = session.status === Status.Authenticated;

  //to set AHL value in session storage for funnel1 journey
  useAHLParam();
  return /*#__PURE__*/jsxs(NavbarWrapper, {
    isTransparent: useTransparent,
    isAuthenticated: isAuthenticated,
    children: [/*#__PURE__*/jsx(NavbarLeftWrapper, {
      children: /*#__PURE__*/jsx(LogoComponent$1, {
        homeURL: homeURL,
        params: params,
        "aria-label": "Logo",
        hasHamburgerMenu: false
      })
    }), /*#__PURE__*/jsx(NavbarRightWrapper, {
      children: /*#__PURE__*/jsx(DropdownProvider, {
        hideDashboardItem: hideDashboardItem,
        hideManageApplicationsItem: hideManageApplicationsItem,
        onLogout: onLogout,
        children: /*#__PURE__*/jsx(CTAButtons$3, {
          showTalkToExpertCta: showTalkToExpertCta,
          showBookanAppointmentCta: showBookanAppointmentCta,
          isAuthenticated: isAuthenticated,
          continueURL: continueURL,
          showContinueAction: showContinueAction,
          openCommPanel: () => isCommPanelOpen ? closeCommPanel() : _openCommPanel(),
          customerOwner: customerOwner,
          hasUnreadMessages: hasUnread
        })
      })
    })]
  });
};
var SimpleNavbar = withErrorProvider(withLendiLDProvider(withCommPanel(withDomainChat(SimpleNavbarComponent))));

var GuestNavbar = _ref => {
  var {
    useTransparent = false,
    homeURL,
    params = ''
  } = _ref;
  return /*#__PURE__*/jsx(NavbarWrapper, {
    isTransparent: useTransparent,
    isAuthenticated: false,
    children: /*#__PURE__*/jsx(NavbarLeftWrapper, {
      children: /*#__PURE__*/jsx(LogoComponent$1, {
        homeURL: homeURL,
        params: params,
        "aria-label": "Logo",
        hasHamburgerMenu: false
      })
    })
  });
};

var MULTI_MENU_OPTIONS = [{
  label: 'Home loans',
  link: '/home-loans/',
  children: [{
    label: 'Find your home loan',
    link: '/home-loans/basics/'
  }, {
    label: 'Refinance your loan',
    link: '/home-loans/refinance/'
  }, {
    label: 'Buy your first home',
    link: '/home-loans/first-home-buyer/'
  }, {
    label: 'Buy your next home',
    link: '/home-loans/buying/'
  }, {
    label: 'Invest in property',
    link: '/home-loans/investment/'
  }, {
    label: 'Build your home',
    link: '/home-loans/construction/'
  }, {
    label: 'Property value report',
    link: '/property-report/'
  }]
}, {
  label: 'Calculators',
  link: '/calculators/',
  children: [{
    label: 'Property report',
    link: '/property-report/'
  }, {
    label: 'Credit score',
    link: '/calculators/check-your-credit-score/'
  }, {
    label: 'Borrowing power calculator',
    link: '/home-loans/calculators/borrowing-power-calculator/'
  }, {
    label: 'Repayment calculator',
    link: '/calculators/home-loan-repayment-calculator/'
  }, {
    label: 'Stamp duty calculator',
    link: '/home-loans/stamp-duty/calculator/?page=0'
  }, {
    label: 'Offset calculator',
    link: '/calculators/offset-calculator/'
  }, {
    label: 'Equity calculator',
    link: '/calculators/equity-calculator/'
  }, {
    label: 'Debt consolidation calculator',
    link: '/calculators/home-loans/debt-consolidation-calculator/'
  }]
}, {
  label: 'Blog',
  link: '/inspire/',
  children: [{
    label: 'Insights',
    link: '/inspire/category/insights/'
  }, {
    label: 'Finance',
    link: '/inspire/category/finance/'
  }, {
    label: 'Lifestyle',
    link: '/inspire/category/lifestyle/'
  }, {
    label: 'Lendi homes',
    link: '/inspire/category/lendi-homes/'
  }, {
    label: 'Property',
    link: '/inspire/category/property/'
  }, {
    label: 'Design',
    link: '/inspire/category/design/'
  }, {
    label: 'Life at Lendi',
    link: '/inspire/category/life-at-lendi/'
  }]
}];

var DesktopActions = _ref => {
  var _window, _window2;
  var {
    isAuthenticated,
    continueURL,
    showContinueAction = false,
    openCommPanel = () => {},
    teamMember,
    hasUnreadMessages,
    showTalkToExpertCta
  } = _ref;
  var brand = getBrandFromHostname();
  var env = getEnvFromHostname((_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.hostname);
  var signInURL = getSignInURL(brand, env, (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.location) === null || _window2 === void 0 ? void 0 : _window2.href);
  var primaryLabel = teamMember !== null && teamMember !== void 0 && teamMember.firstName ? "Talk to ".concat(teamMember.firstName) : brand === 'aussie' ? LABEL_TALK_TO_A_BROKER : LABEL_TALK_TO_EXPERT;
  return /*#__PURE__*/jsxs(DesktopActionsWrapper, {
    children: [showTalkToExpertCta && /*#__PURE__*/jsx(TalkExpertAction$1, {
      variant: "secondary",
      onClick: () => {
        openCommPanel();
        var event = {
          event_name: 'Button Clicked',
          category: EventCategory.NAVBAR,
          buttonType: ButtonType.SECONDARY,
          text: hasUnreadMessages ? 'You have an unread message' : brand === 'aussie' ? 'Talk to a broker' : 'Talk to an expert'
        };
        analytics(event);
      },
      size: "sm",
      bigLabelAccomodate: isAuthenticated ? !showContinueAction : false,
      children: hasUnreadMessages ? /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx(UnreadMessageWrapper, {
          "data-testid": "customer-view-unread-icon",
          color: getColour$1('interaction', 'main'),
          height: "2em",
          width: "2em"
        }), UNREAD_MESSAGE]
      }) : /*#__PURE__*/jsx(Fragment, {
        children: primaryLabel
      })
    }), /*#__PURE__*/jsx(SecondaryAction, {
      bigLabelAccomodate: isAuthenticated ? !showContinueAction : false,
      size: "sm",
      variant: isAuthenticated ? showContinueAction ? 'emphasis' : 'primary' : 'primary',
      href: isAuthenticated ? showContinueAction ? continueURL : ROUTE_BOOK_APPOINTMENT : signInURL,
      onClick: () => {
        var event = {
          event_name: 'Button Clicked',
          category: EventCategory.NAVBAR,
          text: isAuthenticated ? showContinueAction ? 'Continue' : 'Book an Appointment' : 'Sign In',
          buttonType: isAuthenticated ? showContinueAction ? ButtonType.EMPHASIS : ButtonType.PRIMARY : ButtonType.PRIMARY
        };
        analytics(event);
      },
      "aria-label": isAuthenticated ? showContinueAction ? LABEL_CONTINUE : BOOK_AN_APPOINTMENT : signInURL,
      children: isAuthenticated ? showContinueAction ? LABEL_CONTINUE : BOOK_AN_APPOINTMENT : LABEL_SIGN_IN
    }), isAuthenticated && /*#__PURE__*/jsx(LogoutComponent, {})]
  });
};

var MobileActions = _ref => {
  var _window, _window2;
  var {
    isAuthenticated,
    continueURL,
    showContinueAction = false,
    openCommPanel = () => {},
    teamMember,
    hasUnreadMessages,
    showTalkToExpertCta
  } = _ref;
  var brand = getBrandFromHostname();
  var env = getEnvFromHostname((_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.hostname);
  var signInURL = getSignInURL(brand, env, (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.location) === null || _window2 === void 0 ? void 0 : _window2.href);
  var {
    isTransparent
  } = useNavbarBaseContext();
  var secondaryLabel = teamMember !== null && teamMember !== void 0 && teamMember.firstName ? "Talk to ".concat(teamMember.firstName) : CONTACT_US;
  return /*#__PURE__*/jsxs(MobileActionsWrapper, {
    children: [showTalkToExpertCta && /*#__PURE__*/jsx(TalkExpertActionMobile, {
      className: "noHover",
      variant: "secondary",
      onClick: () => {
        openCommPanel();
        var event = {
          event_name: 'Button Clicked',
          category: EventCategory.NAVBAR,
          buttonType: ButtonType.SECONDARY,
          text: hasUnreadMessages ? 'You have an unread message' : 'Contact us'
        };
        analytics(event);
      },
      "aria-label": CONTACT_US,
      size: "sm",
      isInverse: isTransparent,
      isContinue: showContinueAction,
      children: hasUnreadMessages ? /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx(UnreadMessageWrapper, {
          "data-testid": "customer-view-unread-icon",
          color: getColour$1('interaction', 'main'),
          height: "2em",
          width: "2em"
        }), UNREAD_MESSAGE_MOBILE]
      }) : /*#__PURE__*/jsxs(Fragment, {
        children: [" ", secondaryLabel]
      })
    }), isAuthenticated ? /*#__PURE__*/jsx(Fragment, {
      children: showContinueAction && /*#__PURE__*/jsx(SecondaryActionMobile, {
        size: "sm",
        variant: 'emphasis',
        href: continueURL,
        "aria-label": LABEL_CONTINUE,
        onClick: () => {
          var event = {
            event_name: 'Button Clicked',
            category: EventCategory.NAVBAR,
            text: 'Continue',
            buttonType: ButtonType.EMPHASIS
          };
          analytics(event);
        },
        children: LABEL_CONTINUE
      })
    }) : /*#__PURE__*/jsx(SecondaryActionMobile, {
      size: "sm",
      variant: 'primary',
      href: signInURL,
      "aria-label": signInURL,
      onClick: () => {
        var event = {
          event_name: 'Button Clicked',
          category: EventCategory.NAVBAR,
          text: 'Sign In',
          buttonType: ButtonType.PRIMARY
        };
        analytics(event);
      },
      children: LABEL_SIGN_IN
    })]
  });
};

var CTAButtons = props => {
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(DesktopActions, _objectSpread2({}, props)), /*#__PURE__*/jsx(MobileActions, _objectSpread2({}, props))]
  });
};
var CTAButtons$1 = CTAButtons;

var _templateObject$6;
var HamBurgerMenu = _ref => {
  var {
    toggleSidebar,
    leftSidebarState
  } = _ref;
  var {
    isTransparent
  } = useNavbarBaseContext();
  var commonButtonStyle = css(["height:", ";width:", ";color:", ";"], deriveSize(1.6), deriveSize(1.6), _ref2 => {
    var {
      theme
    } = _ref2;
    return isTransparent ? theme.color.interaction.subtle : theme.color.interaction.main;
  });
  var CloseButton = styled(Close).withConfig({
    displayName: "HamBurgerMenu__CloseButton",
    componentId: "lui__sc-y1cjve-0"
  })(["", ""], commonButtonStyle);
  var MenuButton = styled(Menu).withConfig({
    displayName: "HamBurgerMenu__MenuButton",
    componentId: "lui__sc-y1cjve-1"
  })(["", ""], commonButtonStyle);
  return /*#__PURE__*/jsx(HamBurgerWrapper, {
    onClick: () => {
      toggleSidebar(!leftSidebarState);
      var event = {
        event_name: 'Menu Clicked',
        category: EventCategory.NAVBAR,
        menuName: 'Hamburger Menu'
      };
      analytics(event);
    },
    children: leftSidebarState ? /*#__PURE__*/jsx(CloseButton, {
      "aria-label": "close menu"
    }) : /*#__PURE__*/jsx(MenuButton, {
      "aria-label": "open menu"
    })
  });
};
var HamBurgerWrapper = styled.a.withConfig({
  displayName: "HamBurgerMenu__HamBurgerWrapper",
  componentId: "lui__sc-y1cjve-2"
})(["", ";cursor:pointer;"], gte('desktop')(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n    display: none;\n  "]))));
var HamBurgerMenu$1 = HamBurgerMenu;

var ITEM_HEIGHT = '40px';
var ItemsWrapper = styled.ul.withConfig({
  displayName: "indexstyle__ItemsWrapper",
  componentId: "lui__sc-1j3tn22-0"
})(["", ";", ";list-style:none;height:100%;overflow-y:scroll;overflow-x:hidden;"], my('nil'), pl('nil'));
var Item = styled.button.withConfig({
  displayName: "indexstyle__Item",
  componentId: "lui__sc-1j3tn22-1"
})([":last-child{border-bottom:1px solid ", ";}background-color:inherit;border:none;text-align:left;cursor:pointer;border-top:1px solid ", ";font-family:", ";font-weight:600;font-size:11px;text-transform:uppercase;", ";width:100%;height:", ";line-height:", ";", ";:hover{", ";}"], color('shade.100'), color('shade.100'), select('typography.body.fontFamily'), fg('secondary.500'), ITEM_HEIGHT, ITEM_HEIGHT, pl('sm'), bg('shade.25'));
var RightArrow = styled(ArrowDropDown).attrs({
  color: 'secondary.500'
}).withConfig({
  displayName: "indexstyle__RightArrow",
  componentId: "lui__sc-1j3tn22-2"
})(["line-height:0;", ";transform:rotate(-90deg);height:18px;width:18px;transition:transform 0.5s;", ""], mr('sm'), _ref => {
  var {
    shouldRotate
  } = _ref;
  return css(["transform:rotate(", ");"], shouldRotate ? '0deg' : '-90deg');
});
var Accordion = styled.ul.withConfig({
  displayName: "indexstyle__Accordion",
  componentId: "lui__sc-1j3tn22-3"
})(["", ";list-style:none;height:0px;width:100%;transition:height 0.3s linear;overflow:hidden;", ""], pl('nil'), _ref2 => {
  var {
    isVisible,
    children
  } = _ref2;
  return isVisible && css(["height:calc(", " * ", ");"], React.Children.count(children), ITEM_HEIGHT);
});
var SubItem = styled.li.withConfig({
  displayName: "indexstyle__SubItem",
  componentId: "lui__sc-1j3tn22-4"
})(["font-family:", ";font-size:12px;width:100%;", ";height:", ";transition:height 1s ease-out;line-height:", ";background-color:", ";"], select('typography.body.fontFamily'), pl('nil'), ITEM_HEIGHT, ITEM_HEIGHT, color('shade.25'));
var ItemLink = styled.a.withConfig({
  displayName: "indexstyle__ItemLink",
  componentId: "lui__sc-1j3tn22-5"
})(["text-decoration:none;color:", ";width:100%;"], color('secondary.500'));
var SubItemLink = styled.a.withConfig({
  displayName: "indexstyle__SubItemLink",
  componentId: "lui__sc-1j3tn22-6"
})(["text-decoration:none;color:", ";display:block;padding-left:48px;"], color('shade.900'));
var ListItem$1 = styled.li.withConfig({
  displayName: "indexstyle__ListItem",
  componentId: "lui__sc-1j3tn22-7"
})([""]);

var LeftSidebarContent = _ref => {
  var {
    menuOptions: MENU_OPTIONS
  } = _ref;
  var {
    sendFeedback
  } = useFlags();
  var isSVA = checkSVA();
  var [selected, setSelected] = React.useState(-1);
  return /*#__PURE__*/jsxs(ItemsWrapper, {
    role: "menu",
    children: [MENU_OPTIONS.map((item, index) => item.children.length > 0 ? /*#__PURE__*/jsxs(ListItem$1, {
      children: [/*#__PURE__*/jsxs(Item, {
        onClick: () => {
          setSelected(index);
          var event = {
            event_name: 'Menu Clicked',
            menuName: item.label,
            category: EventCategory.NAVBAR
          };
          analytics(event);
        },
        "aria-label": item.label,
        children: [/*#__PURE__*/jsx(RightArrow, {
          shouldRotate: selected === index
        }), /*#__PURE__*/jsx("span", {
          children: item.label
        })]
      }), /*#__PURE__*/jsx(Accordion, {
        isVisible: selected === index,
        "aria-expanded": selected === index,
        children: item.children.map((child, childIndex) => /*#__PURE__*/jsx(SubItem, {
          role: "none",
          children: /*#__PURE__*/jsx(SubItemLink, {
            role: "menuitem",
            href: child.link,
            "aria-label": child.label,
            onClick: () => {
              var event = {
                event_name: 'Menu Element Clicked',
                menuName: item.label,
                text: child.label,
                category: EventCategory.NAVBAR
              };
              analytics(event);
            },
            children: child.label
          })
        }, index + '-' + childIndex))
      })]
    }, index) : /*#__PURE__*/jsx(ListItem$1, {
      role: "none",
      children: item.link ? /*#__PURE__*/jsx(Item, {
        children: /*#__PURE__*/jsx(ItemLink, {
          role: "menuitem",
          href: item.link,
          "aria-label": item.label,
          onClick: () => {
            var event = {
              event_name: 'Menu Element Clicked',
              menuName: item.label,
              text: '',
              category: EventCategory.NAVBAR
            };
            analytics(event);
          },
          children: /*#__PURE__*/jsx("span", {
            children: item.label
          })
        })
      }) : /*#__PURE__*/jsx(Item, {
        "aria-label": item.label,
        children: /*#__PURE__*/jsx("span", {
          children: item.label
        })
      })
    }, index)), sendFeedback && isSVA && /*#__PURE__*/jsx(ListItem$1, {
      role: "none",
      children: /*#__PURE__*/jsx(Item, {
        "aria-label": LABEL_SEND_FEEDBACK,
        onClick: () => {
          var event = {
            event_name: 'Menu Element Clicked',
            menuName: 'Send Feedback',
            text: '',
            category: EventCategory.NAVBAR
          };
          sendFeedBackOnClick();
          analytics(event);
        },
        children: /*#__PURE__*/jsx("span", {
          children: LABEL_SEND_FEEDBACK
        })
      })
    }, "send-feedback")]
  });
};

var FooterCTA = _ref => {
  var {
    isAuthenticated = false,
    continueURL = '/',
    onLogout = () => {},
    showContinueAction = false
  } = _ref;
  var theme = useTheme();
  return /*#__PURE__*/jsxs(FooterWrapper, {
    children: [/*#__PURE__*/jsx(FooterAction, {
      variant: isAuthenticated ? showContinueAction ? 'emphasis' : 'primary' : 'primary',
      isFullWidth: true,
      href: isAuthenticated ? showContinueAction ? continueURL : ROUTE_BOOK_APPOINTMENT : ROUTE_SIGN_IN,
      onClick: () => {
        var event = {
          event_name: 'Button Clicked',
          buttonType: isAuthenticated ? showContinueAction ? ButtonType.EMPHASIS : ButtonType.PRIMARY : ButtonType.PRIMARY,
          text: isAuthenticated ? showContinueAction ? 'Continue' : 'Book an Appointment' : 'Sign In',
          category: EventCategory.NAVBAR
        };
        analytics(event);
      },
      "aria-label": isAuthenticated ? showContinueAction ? LABEL_CONTINUE : BOOK_AN_APPOINTMENT : LABEL_SIGN_IN,
      children: isAuthenticated ? showContinueAction ? LABEL_CONTINUE : BOOK_AN_APPOINTMENT : LABEL_SIGN_IN
    }), isAuthenticated && /*#__PURE__*/jsxs(FooterAction, {
      variant: "empty",
      onClick: () => {
        onLogout();
        var event = {
          event_name: 'Button Clicked',
          buttonType: ButtonType.EMPTY,
          text: 'Log Out',
          category: EventCategory.NAVBAR
        };
        analytics(event);
      },
      "aria-label": LABEL_LOG_OUT,
      children: [/*#__PURE__*/jsx(ExitToApp, {
        color: theme.color.interaction.main
      }), LABEL_LOG_OUT]
    })]
  });
};
var FooterAction = styled(Button).withConfig({
  displayName: "FooterCTA__FooterAction",
  componentId: "lui__sc-uimopi-0"
})(["width:100%;border:none;line-height:1.1;"]);
var FooterWrapper = styled.div.withConfig({
  displayName: "FooterCTA__FooterWrapper",
  componentId: "lui__sc-uimopi-1"
})(["display:flex;flex-direction:column;justify-content:center;align-items:center;box-shadow:0 3px 5px 0 rgba(0,0,0,0.14),0 1px 18px 0 rgba(0,0,0,0.12),0 6px 10px 0 rgba(0,0,0,0.14);", ";", ""], px('sm'), py('sm'));
var FooterCTA$1 = FooterCTA;

var LeftSidebar = _ref => {
  var {
    openSidebar,
    closeSidebar,
    isAuthenticated,
    onLogout,
    continueURL,
    showContinueAction,
    menuOptions
  } = _ref;
  // Left sidebar only appears for mobile/tablet and navbar-base height will be 56px, which could be offsetTop value for left-sidebar.
  return /*#__PURE__*/jsxs(Sidebar, {
    isVisible: openSidebar,
    onHide: closeSidebar,
    top: 56,
    children: [/*#__PURE__*/jsx(Sidebar.Content, {
      children: /*#__PURE__*/jsx(LeftSidebarContent, {
        menuOptions: menuOptions
      })
    }), /*#__PURE__*/jsx(Sidebar.Footer, {
      children: /*#__PURE__*/jsx(FooterCTA$1, {
        isAuthenticated: isAuthenticated,
        onLogout: onLogout,
        continueURL: continueURL,
        showContinueAction: showContinueAction
      })
    })]
  });
};
var LeftSidebar$1 = LeftSidebar;

var _templateObject$5;
var PanelLink = styled(Link).withConfig({
  displayName: "indexstyle__PanelLink",
  componentId: "lui__sc-56jb5a-0"
})(["text-decoration:none;overflow:hidden;font-weight:normal;:hover,:focus,:active{", "}"], fg('shade.700'));
var PanelButton = styled(Button).withConfig({
  displayName: "indexstyle__PanelButton",
  componentId: "lui__sc-56jb5a-1"
})(["", ""], ml('sm'));
var LinksGroup = styled.ul.withConfig({
  displayName: "indexstyle__LinksGroup",
  componentId: "lui__sc-56jb5a-2"
})(["list-style-type:none;", " ", " ", ""], grid(), p('nil'), m('nil'));
var LinkItem = styled.li.withConfig({
  displayName: "indexstyle__LinkItem",
  componentId: "lui__sc-56jb5a-3"
})(["", " ", " ", ""], unit({
  size: 1 / 4
}), py('xxs'), pr('xs'));
var HeadingWrapper = styled.div.withConfig({
  displayName: "indexstyle__HeadingWrapper",
  componentId: "lui__sc-56jb5a-4"
})(["display:flex;flex-direction:row;align-items:center;", ""], mb('xs'));
var HeadingLink = styled(Link).withConfig({
  displayName: "indexstyle__HeadingLink",
  componentId: "lui__sc-56jb5a-5"
})(["display:flex;flex-direction:row;align-items:center;overflow:hidden;text-decoration:none;:hover,:focus,:active{", "}"], fg('secondary.500'));
var DisplayPanel = styled.div.withConfig({
  displayName: "indexstyle__DisplayPanel",
  componentId: "lui__sc-56jb5a-6"
})(["width:100%;position:absolute;margin-top:10px;border-radius:", ";max-width:500px;left:0;", " ", " ", ""], select('borderRadius'), depth(4), bg('shade.0'), p('md'));
var Bar = styled.div.withConfig({
  displayName: "indexstyle__Bar",
  componentId: "lui__sc-56jb5a-7"
})(["height:2px;width:", ";transition:width ease-in-out 300ms;", ""], _ref => {
  var {
    isSelected
  } = _ref;
  return isSelected ? 'calc(100% - 16px)' : '0';
}, _ref2 => {
  var {
    isTransparent
  } = _ref2;
  return isTransparent ? css(["", ""], bg('shade.0')) : css(["", ";"], bg('secondary.500'));
});
var UnOrderedList = styled.ul.withConfig({
  displayName: "indexstyle__UnOrderedList",
  componentId: "lui__sc-56jb5a-8"
})(["list-style-type:none;display:flex;flex-direction:row;justify-content:center;align-items:center;", " ", ""], p('nil'), m('nil'));
var ListItem = styled.li.withConfig({
  displayName: "indexstyle__ListItem",
  componentId: "lui__sc-56jb5a-9"
})(["list-style-type:none;"]);
var LinkOption = styled(Link).withConfig({
  displayName: "indexstyle__LinkOption",
  componentId: "lui__sc-56jb5a-10"
})(["display:inline-flex;flex-direction:column;overflow:hidden;", ";", ";text-decoration:none;:hover,:focus,:active{text-decoration:none;}color:", ";"], pr('md'), pl('nil'), _ref3 => {
  var {
    theme,
    isTransparent
  } = _ref3;
  if (isTransparent) return theme.color.text.inverse;
  if (theme.name === 'lendi') return theme.color.text.contrast;
  return theme.color.text.contrast;
});
var ExpandMoreWrapper = styled(ExpandMore).withConfig({
  displayName: "indexstyle__ExpandMoreWrapper",
  componentId: "lui__sc-56jb5a-11"
})(["& svg{display:block;}font-weight:bold;transform:", ";transition:transform ease-in-out 300ms;color:", ";"], _ref4 => {
  var {
    isSelected
  } = _ref4;
  return isSelected ? 'rotate(180deg)' : undefined;
}, _ref5 => {
  var {
    theme,
    isTransparent
  } = _ref5;
  if (isTransparent) return theme.color.text.inverse;
  return theme.color.text.contrast;
});
var BarWrapper = styled.div.withConfig({
  displayName: "indexstyle__BarWrapper",
  componentId: "lui__sc-56jb5a-12"
})(["display:inline-flex;align-items:center;"]);
var Label = styled(Body).withConfig({
  displayName: "indexstyle__Label",
  componentId: "lui__sc-56jb5a-13"
})(["text-transform:uppercase;font-weight:bold;letter-spacing:0.8px;line-height:1;"]);
var OptionsContainer = styled.div.withConfig({
  displayName: "indexstyle__OptionsContainer",
  componentId: "lui__sc-56jb5a-14"
})(["width:100%;display:none;flex-direction:row;justify-content:space-between;align-items:center;", " ", ""], ml('lg'), gte('desktop')(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n  display: flex;\n  position: relative;\n"]))));

var prevSelected = '';
var MenuOptions = props => {
  var {
    isTransparent
  } = useNavbarBaseContext();
  var {
    isAuthenticated,
    params,
    continueURL
  } = props;
  var [currentSelected, setCurrentSelected] = React.useState('');
  var displayPanel = React.useRef(null);
  var selectedItem = MULTI_MENU_OPTIONS.find(menuItem => menuItem.label === currentSelected);
  var hasWindow = typeof window !== 'undefined';
  React.useEffect(() => {
    if (hasWindow) {
      window.addEventListener('mousedown', closeDisplayPanel);
    }
    return () => {
      if (hasWindow) {
        window.removeEventListener('mousedown', closeDisplayPanel);
      }
    };
  });
  var closeDisplayPanel = e => {
    prevSelected = currentSelected;
    if (displayPanel && displayPanel.current && !displayPanel.current.contains(e.target)) {
      setCurrentSelected('');
    }
  };
  return /*#__PURE__*/jsx(OptionsContainer, {
    children: /*#__PURE__*/jsx(UnOrderedList, {
      children: MULTI_MENU_OPTIONS.map(_ref => {
        var {
          label,
          children
        } = _ref;
        return /*#__PURE__*/jsxs(ListItem, {
          children: [/*#__PURE__*/jsxs(LinkOption, {
            onClick: () => {
              onClickOption(label, setCurrentSelected);
              var event = {
                event_name: 'Menu Clicked',
                category: EventCategory.NAVBAR,
                menuName: label
              };
              analytics(event);
            },
            isTransparent: isTransparent,
            type: "button",
            children: [/*#__PURE__*/jsxs(BarWrapper, {
              children: [/*#__PURE__*/jsx(Label, {
                size: "xs",
                children: label
              }), children && /*#__PURE__*/jsx(ExpandMoreWrapper, {
                isSelected: currentSelected === label,
                isTransparent: isTransparent
              })]
            }), children && /*#__PURE__*/jsx(Bar, {
              isSelected: currentSelected === label,
              isTransparent: isTransparent
            })]
          }), currentSelected === label && /*#__PURE__*/jsxs(DisplayPanel, {
            ref: displayPanel,
            children: [/*#__PURE__*/jsxs(HeadingWrapper, {
              children: [/*#__PURE__*/jsxs(HeadingLink, {
                href: "".concat(selectedItem.link || '').concat(params),
                onClick: () => {
                  var event = {
                    event_name: 'Menu Element Clicked',
                    menuName: currentSelected,
                    text: selectedItem.label,
                    category: EventCategory.NAVBAR
                  };
                  analytics(event);
                },
                children: [/*#__PURE__*/jsx(Heading, {
                  size: "md",
                  color: "secondary.500",
                  mr: "xxs",
                  children: currentSelected
                }), /*#__PURE__*/jsx(KeyboardArrowRight, {
                  color: "secondary.500"
                })]
              }), currentSelected === 'Home loans' && /*#__PURE__*/jsx(PanelButton, {
                size: "xs",
                variant: isAuthenticated ? 'emphasis' : 'primary',
                href: isAuthenticated ? continueURL : ROUTE_SIGN_IN,
                onClick: () => {
                  var event = {
                    event_name: 'Menu Element Clicked',
                    category: EventCategory.NAVBAR,
                    menuName: currentSelected,
                    text: isAuthenticated ? 'Continue' : 'Sign In'
                  };
                  analytics(event);
                },
                children: isAuthenticated ? LABEL_CONTINUE : LABEL_SIGN_IN
              })]
            }), /*#__PURE__*/jsx(LinksGroup, {
              children: selectedItem.children.map(child => /*#__PURE__*/jsx(LinkItem, {
                children: /*#__PURE__*/jsx(PanelLink, {
                  size: "sm",
                  color: "shade.700",
                  href: "".concat(child.link).concat(params),
                  onClick: () => {
                    var event = {
                      event_name: 'Menu Element Clicked',
                      menuName: selectedItem.label,
                      text: child.label,
                      category: EventCategory.NAVBAR
                    };
                    analytics(event);
                  },
                  children: child.label
                })
              }, child.label))
            })]
          })]
        }, label);
      })
    })
  });
};
var onClickOption = (label, setCurrentSelected) => {
  if (prevSelected === label) {
    setCurrentSelected('');
  } else {
    setCurrentSelected(label);
  }
};
var MenuOptions$1 = MenuOptions;

var _excluded$8 = ["useTransparent", "homeURL", "params", "continueURL", "onLogout", "application", "showContinueAction", "showTalkToExpertCta", "hideDashboardItem", "hideManageApplicationsItem", "isCommPanelOpen", "hasUnread", "closeCommPanel", "openCommPanel", "customerOwner"];
var MultiNavbarComponent = _ref => {
  var {
      // Public props
      useTransparent = false,
      homeURL,
      params = '',
      continueURL = '/',
      onLogout = () => {},
      application,
      showContinueAction,
      showTalkToExpertCta,
      hideDashboardItem,
      hideManageApplicationsItem,
      // Internal props, from ChatProps
      isCommPanelOpen,
      hasUnread,
      closeCommPanel,
      openCommPanel: _openCommPanel,
      customerOwner
    } = _ref,
    otherProps = _objectWithoutProperties(_ref, _excluded$8);
  var session = useSession();
  var isAuthenticated = session.status === Status.Authenticated;
  var [leftSidebarState, setLeftSidebarState] = React.useState(false);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(LeftSidebar$1, {
      menuOptions: MULTI_MENU_OPTIONS,
      openSidebar: leftSidebarState,
      closeSidebar: () => setLeftSidebarState(false),
      isAuthenticated: isAuthenticated,
      continueURL: continueURL,
      onLogout: onLogout,
      showContinueAction: showContinueAction
    }), /*#__PURE__*/jsxs(NavbarWrapper, _objectSpread2(_objectSpread2({
      isTransparent: useTransparent,
      isAuthenticated: isAuthenticated
    }, otherProps), {}, {
      children: [/*#__PURE__*/jsx(NavbarLeftWrapper, {
        children: /*#__PURE__*/jsxs(Container, {
          children: [/*#__PURE__*/jsxs(MenuLogoWrapper, {
            children: [/*#__PURE__*/jsx(HamBurgerMenu$1, {
              toggleSidebar: toggle => setLeftSidebarState(toggle),
              leftSidebarState: leftSidebarState
            }), /*#__PURE__*/jsx(LogoComponent$1, {
              homeURL: homeURL,
              params: params
            })]
          }), /*#__PURE__*/jsx(MenuOptions$1, {
            isAuthenticated: isAuthenticated,
            continueURL: continueURL,
            params: params
          })]
        })
      }), /*#__PURE__*/jsx(NavbarRightWrapper, {
        children: /*#__PURE__*/jsx(DropdownProvider, {
          hideDashboardItem: hideDashboardItem,
          hideManageApplicationsItem: hideManageApplicationsItem,
          onLogout: onLogout,
          children: /*#__PURE__*/jsx(CTAButtons$1, {
            showTalkToExpertCta: showTalkToExpertCta,
            isAuthenticated: isAuthenticated,
            continueURL: continueURL,
            showContinueAction: showContinueAction,
            openCommPanel: () => isCommPanelOpen ? closeCommPanel() : _openCommPanel(),
            customerOwner: customerOwner,
            hasUnreadMessages: hasUnread
          })
        })
      })]
    }))]
  });
};
var MultiNavbar = withErrorProvider(withLendiLDProvider(withCommPanel(withDomainChat(MultiNavbarComponent))));

var _templateObject$4, _templateObject2$2, _templateObject3$1, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
var LargeTweakpoint = '67rem';
var Px = css(["padding-left:", ";padding-right:", ";"], pxToRem(16), pxToRem(16));
var Py = css(["padding-top:", ";padding-bottom:", ";"], pxToRem(24), pxToRem(24));
var MenuPadding = styled.div.withConfig({
  displayName: "sharedstyles__MenuPadding",
  componentId: "lui__sc-631j2u-0"
})(["", ";", ";"], Px, Py);
var MenuPaddingAlt = styled.div.withConfig({
  displayName: "sharedstyles__MenuPaddingAlt",
  componentId: "lui__sc-631j2u-1"
})(["padding-top:", ";padding-bottom:", ";", ";"], pxToRem(24), pxToRem(12), Px);
var listReset = css(["margin:0;list-style:none;padding:0;"]);
var buttonReset = css(["border:0;border-radius:0;background:none;width:100%;white-space:nowrap;text-decoration:none;margin:0;cursor:pointer;"]);
var insetFocusVisible = css(["&:focus-visible{background-color:#331745;outline:0;box-shadow:inset ", " 0.125rem 0.125rem 0 0,inset ", " -0.125rem -0.125rem 0 0,inset ", " 0.25rem 0.25rem 0 0,inset ", " -0.25rem -0.25rem 0 0;}"], _ref => {
  var {
    theme
  } = _ref;
  return theme.color.border.interaction.focus;
}, _ref2 => {
  var {
    theme
  } = _ref2;
  return theme.color.border.interaction.focus;
}, _ref3 => {
  var {
    theme
  } = _ref3;
  return theme.color.fill.main;
}, _ref4 => {
  var {
    theme
  } = _ref4;
  return theme.color.fill.main;
});
var focusVisible = css(["&:focus-visible{outline:0;box-shadow:", ";}"], getFocusRing());
var StyledHR = styled.hr.withConfig({
  displayName: "sharedstyles__StyledHR",
  componentId: "lui__sc-631j2u-2"
})(["margin-top:", ";margin-bottom:", ";&:last-child{margin-bottom:0;}"], pxToRem(24), pxToRem(24));
styled.div.withConfig({
  displayName: "sharedstyles__HideFromLarge",
  componentId: "lui__sc-631j2u-3"
})(["display:block;", ""], gte('lg')(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n    display: none;\n  "]))));
var HideFromTweakLarge = styled.div.withConfig({
  displayName: "sharedstyles__HideFromTweakLarge",
  componentId: "lui__sc-631j2u-4"
})(["display:block;@media (min-width:", "){display:none;}"], LargeTweakpoint);
var ShowFromTweakLarge = styled.div.withConfig({
  displayName: "sharedstyles__ShowFromTweakLarge",
  componentId: "lui__sc-631j2u-5"
})(["display:none;@media (min-width:", "){display:block;}"], LargeTweakpoint);
styled.div.withConfig({
  displayName: "sharedstyles__ShowFromLarge",
  componentId: "lui__sc-631j2u-6"
})(["display:none;", ""], gte('lg')(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n    display: block;\n  "]))));
var HideFromMedium = styled.div.withConfig({
  displayName: "sharedstyles__HideFromMedium",
  componentId: "lui__sc-631j2u-7"
})(["display:block;", ""], gte('md')(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n    display: none;\n  "]))));
var ShowFromMedium = styled.div.withConfig({
  displayName: "sharedstyles__ShowFromMedium",
  componentId: "lui__sc-631j2u-8"
})(["display:none;", ""], gte('md')(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    display: block;\n  "]))));
var ShowFromSmall = styled.div.withConfig({
  displayName: "sharedstyles__ShowFromSmall",
  componentId: "lui__sc-631j2u-9"
})(["display:none;", ""], gte('sm')(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    display: block;\n  "]))));
styled.div.withConfig({
  displayName: "sharedstyles__HideFromSmall",
  componentId: "lui__sc-631j2u-10"
})(["display:block;", ""], gte('sm')(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    display: none;\n  "]))));
var ShowAtSmallOnly = styled.div.withConfig({
  displayName: "sharedstyles__ShowAtSmallOnly",
  componentId: "lui__sc-631j2u-11"
})(["display:none;", ";"], between('xs', 'sm')(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    display: block;\n  "]))));
var ShowAtMediumOnly = styled.div.withConfig({
  displayName: "sharedstyles__ShowAtMediumOnly",
  componentId: "lui__sc-631j2u-12"
})(["display:none;", ";"], between('sm', 'lg')(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    display: block;\n  "]))));
var SrOnlySpan = styled.span.withConfig({
  displayName: "sharedstyles__SrOnlySpan",
  componentId: "lui__sc-631j2u-13"
})(["", ";"], srOnly);

var _excluded$7 = ["children", "isOpen", "onClick"],
  _excluded2$1 = ["children", "href", "onClick", "isActive"];
/**
 * @todo Line-height: prefer to use token but the current one is not accessible here
 * @todo Helper functions: getTypography you have to specify each property of the font you need should this be simpler
 * @todo Colors: Access the color pallett or update to semantic values
 * @todo Remove font smoothing when wider solution reached for when we remove it globally
 */

var StyledNavButton = styled.button.withConfig({
  displayName: "NavButtons__StyledNavButton",
  componentId: "lui__sc-1rf7mpw-0"
})(["", ";color:", ";background-color:", ";font-family:", ";font-weight:", ";font-size:", ";line-height:1.5;padding:", " ", ";display:flex;align-items:center;justify-content:space-between;&:hover{color:", ";}", " ", ""], buttonReset, _ref => {
  var {
    theme
  } = _ref;
  return theme.color.text.inverse;
}, _ref2 => {
  var {
    theme
  } = _ref2;
  return theme.color.interaction.main;
}, () => getTypography('button1', 'fontFamily'), () => getTypography('button1', 'fontWeight'), pxToRem(16), pxToRem(12), pxToRem(16), _ref3 => {
  var {
    theme
  } = _ref3;
  return theme.color.interaction.emphasis;
}, _ref4 => {
  var {
    isOpen,
    isActive,
    theme
  } = _ref4;
  return (isOpen !== null && isOpen !== void 0 ? isOpen : isActive) ? "color: ".concat(theme.color.interaction.emphasis, ";") : null;
}, insetFocusVisible);
var StyledNavButtonText = styled.span.withConfig({
  displayName: "NavButtons__StyledNavButtonText",
  componentId: "lui__sc-1rf7mpw-1"
})(["margin-right:", ";"], pxToRem(4));
var NavButton = _ref5 => {
  var {
      children,
      isOpen = false,
      onClick
    } = _ref5,
    props = _objectWithoutProperties(_ref5, _excluded$7);
  var globalProps = filterGlobalProps(props);
  return /*#__PURE__*/jsxs(StyledNavButton, _objectSpread2(_objectSpread2({
    type: "button",
    "aria-expanded": isOpen,
    isOpen: isOpen,
    onClick: onClick
  }, globalProps), {}, {
    children: [/*#__PURE__*/jsx(StyledNavButtonText, {
      children: children
    }), !isOpen ? /*#__PURE__*/jsx(ChevronDown, {
      width: "21px",
      height: "21px"
    }) : /*#__PURE__*/jsx(ChevronUp, {
      width: "21px",
      height: "21px"
    })]
  }));
};
var NavLink = _ref6 => {
  var {
      children,
      href,
      onClick,
      isActive
    } = _ref6,
    props = _objectWithoutProperties(_ref6, _excluded2$1);
  var globalProps = filterGlobalProps(props);
  return /*#__PURE__*/jsx(StyledNavButton, _objectSpread2(_objectSpread2({
    href: href,
    as: "a",
    onClick: onClick,
    isActive: isActive
  }, globalProps), {}, {
    children: /*#__PURE__*/jsx("span", {
      children: children
    })
  }));
};

var _excluded$6 = ["children", "align", "minWidth", "className"];
/**
 * @todo Border radius: Update border radius to use tokens or replace with exisiting mechanism
 * @todo Colors: Access the color pallett or update to semantic values
 */

var StyledDropdown$1 = styled.div.withConfig({
  displayName: "Dropdown__StyledDropdown",
  componentId: "lui__sc-1mv978l-0"
})(["display:block;position:absolute;background:#4b1f68;border-radius:0px 0px ", " ", ";top:100%;", ";min-width:", ";max-width:", ";overflow:hidden;"], pxToRem(16), pxToRem(16), _ref => {
  var {
    align
  } = _ref;
  return align === 'right' ? "right: 0" : "left: 0";
}, _ref2 => {
  var {
    minWidth
  } = _ref2;
  return minWidth !== null && minWidth !== void 0 ? minWidth : pxToRem(222);
}, pxToRem(300));
var DropdownComponent = (_ref3, ref) => {
  var {
      children,
      align,
      minWidth,
      className
    } = _ref3,
    props = _objectWithoutProperties(_ref3, _excluded$6);
  var globalProps = filterGlobalProps(props);
  return /*#__PURE__*/jsx(StyledDropdown$1, _objectSpread2(_objectSpread2({
    className: className,
    align: align,
    minWidth: minWidth,
    role: "menu",
    ref: ref
  }, globalProps), {}, {
    children: children
  }));
};
var Dropdown = /*#__PURE__*/forwardRef(DropdownComponent);

var _excluded$5 = ["navSlot", "ctaSlot"];
var _templateObject$3, _templateObject2$1;
var HeaderPaddingSmall = 10;
var HeaderPaddingLarge = 24;

/**
 * @todo z-index: tokenise z-index to make it easier to manage levels
 */
var StyledHeader = styled.header.withConfig({
  displayName: "HeaderBase__StyledHeader",
  componentId: "lui__sc-1ik75ai-0"
})(["background:", ";position:sticky;top:0;z-index:999;padding:", " 0;", ""], _ref => {
  var {
    theme
  } = _ref;
  return theme.color.fill.contrast;
}, pxToRem(HeaderPaddingSmall), gte('md')(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n    padding: ", " 0;\n  "])), pxToRem(HeaderPaddingLarge)));
var HeaderInner = styled.div.withConfig({
  displayName: "HeaderBase__HeaderInner",
  componentId: "lui__sc-1ik75ai-1"
})(["display:flex;align-items:center;"]);
var LogoLink = styled.a.withConfig({
  displayName: "HeaderBase__LogoLink",
  componentId: "lui__sc-1ik75ai-2"
})(["width:", ";height:", ";order:1;flex:0 0 auto;", " ", ""], pxToRem(87), pxToRem(16), gte('md')(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n    width: ", ";\n    height: ", ";\n    margin-right: ", ";\n  "])), pxToRem(150), pxToRem(28), pxToRem(32)), focusVisible);
var StyledNavSlot = styled.div.withConfig({
  displayName: "HeaderBase__StyledNavSlot",
  componentId: "lui__sc-1ik75ai-3"
})(["order:3;@media (min-width:", "){order:2;}"], LargeTweakpoint);
var StyledCtaSlot = styled.div.withConfig({
  displayName: "HeaderBase__StyledCtaSlot",
  componentId: "lui__sc-1ik75ai-4"
})(["margin-left:auto;order:2;@media (min-width:", "){order:3;}"], LargeTweakpoint);
var HeaderBase = _ref2 => {
  var {
      navSlot,
      ctaSlot
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded$5);
  var globalProps = filterGlobalProps(props);
  return /*#__PURE__*/jsx(StyledHeader, _objectSpread2(_objectSpread2({
    role: "banner"
  }, globalProps), {}, {
    children: /*#__PURE__*/jsx(Wrapper, {
      children: /*#__PURE__*/jsxs(HeaderInner, {
        children: [/*#__PURE__*/jsxs(LogoLink, {
          href: "/",
          onClick: () => {
            var event = {
              event_name: 'Link Clicked',
              category: EventCategory.NAVBAR,
              position: EventCategory.CMS,
              text: 'Logo',
              linkType: 'Logo',
              customerType: CustomerType.CUSTOMER
            };
            analytics(event);
          },
          children: [/*#__PURE__*/jsx(Logo, {
            variant: "light",
            width: "100%",
            height: "auto",
            brand: "aussie"
          }), /*#__PURE__*/jsx(SrOnlySpan, {
            children: "Go to Aussie homepage"
          })]
        }), /*#__PURE__*/jsx(StyledNavSlot, {
          children: navSlot
        }), /*#__PURE__*/jsx(StyledCtaSlot, {
          children: ctaSlot
        })]
      })
    })
  }));
};

var _excluded$4 = ["label", "children", "onClick", "minDropdownWidth", "align"];
var _templateObject$2;
// Make dropdown content flush to the bottom of the header not it's trigger button
var StyledDropdown = styled(Dropdown).withConfig({
  displayName: "NavDropdown__StyledDropdown",
  componentId: "lui__sc-1xymxh7-0"
})(["", ";", " ", ""], _ref => {
  var {
    minWidth
  } = _ref;
  return minWidth && "min-width: ".concat(minWidth);
}, () => css(["top:calc(100% + ", ");"], pxToRem(HeaderPaddingSmall)), () => css(["", ""], gte('md')(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n        top: calc(100% + ", ");\n        "])), pxToRem(HeaderPaddingLarge))));
var NavDropdown = _ref2 => {
  var {
      label,
      children,
      onClick,
      minDropdownWidth,
      align = 'left'
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded$4);
  var globalProps = filterGlobalProps(props);
  var dropdownRef = useRef(null);
  var dropdownGroupRef = useRef(null);
  var [isOpen, setIsOpen] = useState(false);
  var handleClick = event => {
    setIsOpen(!isOpen);
    onClick === null || onClick === void 0 || onClick(event, !isOpen);
  };
  var pageClickEvent = event => {
    var target = event.target;

    /**
     * When button clicked, global click event will be fired as well, but after the button click event.
     * So we need prevent global event fired when user click button.
     *
     * When the button click event fired, the icon will be changed. So event target will be the unmounted svg.
     * That unmounted svg will hack the contains logic. So we do mount check on line.67
     */
    if (!target.isConnected) return;
    if (dropdownRef.current && dropdownGroupRef.current && !dropdownGroupRef.current.contains(target)) {
      setIsOpen(false);
    }
  };
  var escapeEvent = event => {
    if (event.key === 'Escape' && isOpen) {
      setIsOpen(!isOpen);
    }
  };
  useEffect(() => {
    // If the item is open listen for clicks or escape key
    if (isOpen) {
      window.addEventListener('click', pageClickEvent);
      window.addEventListener('keydown', escapeEvent);
    }
    return () => {
      window.removeEventListener('click', pageClickEvent);
      window.removeEventListener('keydown', escapeEvent);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);
  return (
    /*#__PURE__*/
    // Needs to be relative so we position the dropdown content relative to this wrapper
    jsxs("div", _objectSpread2(_objectSpread2({}, globalProps), {}, {
      style: {
        position: 'relative'
      },
      ref: dropdownGroupRef,
      children: [/*#__PURE__*/jsx(NavButton, {
        isOpen: isOpen,
        onClick: e => handleClick(e),
        children: label
      }), /*#__PURE__*/jsx(FocusLock, {
        disabled: !isOpen,
        returnFocus: true,
        children: isOpen && /*#__PURE__*/jsx(StyledDropdown, {
          minWidth: minDropdownWidth,
          align: align,
          ref: dropdownRef,
          children: children
        })
      })]
    }))
  );
};

var _excluded$3 = ["children", "href", "background", "isActive", "isExternal", "onClick"],
  _excluded2 = ["children", "onClick"];
/**
 * @todo Line-height: prefer to use token but the current one is not accessible here
 * @todo Helper functions: getTypography you have to specify each property of the font you need should this be simpler
 * @todo Colors: Access the color palette or update to semantic values
 */

var MenuItemStyles = css(["padding:", " ", ";color:", ";font-family:", ";font-weight:", ";font-size:", ";line-height:1.5;text-decoration:none;&:hover{background-color:#633482;}", ""], pxToRem(12), pxToRem(16), _ref => {
  var {
    theme
  } = _ref;
  return theme.color.text.inverse;
}, () => getTypography('body1', 'fontFamily'), () => getTypography('body1', 'fontWeight'), pxToRem(16), insetFocusVisible);
var StyledMenuLink = styled.a.withConfig({
  displayName: "MenuLink__StyledMenuLink",
  componentId: "lui__sc-dpbddc-0"
})(["", " background-color:", ";display:flex;align-items:center;justify-content:space-between;position:relative;", ""], () => MenuItemStyles, _ref2 => {
  var {
    background,
    theme
  } = _ref2;
  return background === 'darker' ? '#331745' : theme.color.interaction.main;
}, _ref3 => {
  var {
    isActive,
    theme
  } = _ref3;
  return isActive && "background-color: #633482;\n    font-weight: bold;\n\n    &:before {\n      content: '';\n      position: absolute;\n      top: 0;\n      left: 0;\n      width: 4px;\n      height: 100%;\n      background-color: ".concat(theme.color.interaction.emphasis, ";\n    }\n\n  ");
});
var ExternalIcon = styled.span.withConfig({
  displayName: "MenuLink__ExternalIcon",
  componentId: "lui__sc-dpbddc-1"
})(["transform:rotate(-45deg);width:", ";height:", ";"], pxToRem(24), pxToRem(24));
var MenuLink = _ref4 => {
  var {
      children,
      href,
      background,
      isActive = false,
      isExternal = false,
      onClick
    } = _ref4,
    props = _objectWithoutProperties(_ref4, _excluded$3);
  var globalProps = filterGlobalProps(props);
  var conditionalProps = {};
  if (isExternal) {
    conditionalProps = {
      target: '_blank',
      rel: 'noopener'
    };
  }
  if (isActive) {
    conditionalProps = {
      'aria-current': 'page'
    };
  }
  return /*#__PURE__*/jsxs(StyledMenuLink, _objectSpread2(_objectSpread2(_objectSpread2({
    href: href,
    isActive: isActive,
    onClick: onClick,
    background: background
  }, conditionalProps), globalProps), {}, {
    children: [/*#__PURE__*/jsx("span", {
      children: children
    }), isExternal && /*#__PURE__*/jsxs(ExternalIcon, {
      children: [/*#__PURE__*/jsx(ArrowForward, {
        width: pxToRem(24),
        height: pxToRem(24)
      }), /*#__PURE__*/jsx(SrOnlySpan, {
        children: " (Opens in new window)"
      })]
    })]
  }));
};
/**
 * @todo Colors: Access the color palette or update to semantic values
 */

var StyledMenuButton = styled.button.withConfig({
  displayName: "MenuLink__StyledMenuButton",
  componentId: "lui__sc-dpbddc-2"
})(["", ";", ";text-align:left;"], () => buttonReset, () => MenuItemStyles);
var MenuButton = _ref5 => {
  var {
      children,
      onClick
    } = _ref5,
    props = _objectWithoutProperties(_ref5, _excluded2);
  var globalProps = filterGlobalProps(props);
  return /*#__PURE__*/jsx(StyledMenuButton, _objectSpread2(_objectSpread2({
    type: "button",
    onClick: onClick
  }, globalProps), {}, {
    children: children
  }));
};

var _excluded$2 = ["navOptions", "isSlideout"];
var NavMobileStyled = css(["ul{", "}"], listReset);
var NavDesktopStyled = css(["ul{", ";display:flex;align-items:center;}"], listReset);
var NavElement = styled.nav.withConfig({
  displayName: "Nav__NavElement",
  componentId: "lui__sc-zq7yzs-0"
})(["", ""], _ref => {
  var {
    isSlideout
  } = _ref;
  return isSlideout ? NavMobileStyled : NavDesktopStyled;
});
var StyledChildrenWrapper = styled.div.withConfig({
  displayName: "Nav__StyledChildrenWrapper",
  componentId: "lui__sc-zq7yzs-1"
})(["::after{content:'';display:block;", "}"], _ref2 => {
  var {
    isOpen,
    theme
  } = _ref2;
  return isOpen && "height: 0.0625rem; background-color: ".concat(theme.color.text.inverse, "; margin: .75rem 1rem;");
});
var MenuItem = _ref3 => {
  var {
    label,
    children
  } = _ref3;
  var [isOpen, setIsOpen] = useState(false);
  var handleClick = () => {
    setIsOpen(!isOpen);
    var event = {
      event_name: 'Menu Clicked',
      category: EventCategory.NAVBAR,
      menuName: label,
      position: 'CMS',
      customerType: CustomerType.CUSTOMER
    };
    analytics(event);
  };
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(NavButton, {
      onClick: () => handleClick(),
      isOpen: isOpen,
      children: label
    }), isOpen && /*#__PURE__*/jsx(StyledChildrenWrapper, {
      isOpen: isOpen,
      children: children
    })]
  });
};
var Nav = _ref4 => {
  var {
      navOptions,
      isSlideout
    } = _ref4,
    props = _objectWithoutProperties(_ref4, _excluded$2);
  var globalProps = filterGlobalProps(props);
  var listItems = navOptions.map((item, index) => {
    var _item$children, _item$children2;
    var navItems = isSlideout ? /*#__PURE__*/jsx(MenuItem, {
      label: item.label,
      children: (_item$children = item.children) === null || _item$children === void 0 ? void 0 : _item$children.map((childItem, index) => {
        return /*#__PURE__*/jsx(MenuLink, {
          href: childItem.link,
          isActive: childItem.isActive,
          onClick: () => {
            var event = {
              category: EventCategory.NAVBAR,
              event_name: 'Menu Element Clicked',
              menuName: item.label,
              text: childItem.label,
              position: EventCategory.CMS,
              customerType: CustomerType.CUSTOMER
            };
            analytics(event);
          },
          children: childItem.label
        }, index);
      })
    }) : /*#__PURE__*/jsx(NavDropdown, {
      label: item.label,
      minDropdownWidth: item === null || item === void 0 ? void 0 : item.minDropdownWidth,
      onClick: () => {
        var event = {
          event_name: 'Menu Clicked',
          category: EventCategory.NAVBAR,
          menuName: item.label,
          position: 'CMS',
          customerType: CustomerType.CUSTOMER
        };
        analytics(event);
      },
      children: (_item$children2 = item.children) === null || _item$children2 === void 0 ? void 0 : _item$children2.map((childItem, index) => {
        return /*#__PURE__*/jsx(MenuLink, {
          href: childItem.link,
          isActive: childItem.isActive,
          onClick: () => {
            var event = {
              category: EventCategory.NAVBAR,
              event_name: 'Menu Element Clicked',
              menuName: item.label,
              text: childItem.label,
              position: EventCategory.CMS,
              customerType: CustomerType.CUSTOMER
            };
            analytics(event);
          },
          children: childItem.label
        }, index);
      })
    });
    if (Object.prototype.hasOwnProperty.call(item, 'children')) {
      return /*#__PURE__*/jsx("li", {
        children: navItems
      }, index);
    }
    return item.link && /*#__PURE__*/jsx("li", {
      children: /*#__PURE__*/jsx(NavLink, {
        href: item.link,
        isActive: item.isActive,
        onClick: () => {
          var event = {
            event_name: 'Link Clicked',
            category: EventCategory.NAVBAR,
            text: item.label,
            linkType: 'LinkToPage',
            position: EventCategory.CMS,
            customerType: CustomerType.CUSTOMER
          };
          analytics(event);
        },
        children: item.label
      })
    }, index);
  });
  return /*#__PURE__*/jsx(NavElement, _objectSpread2(_objectSpread2({
    isSlideout: isSlideout
  }, globalProps), {}, {
    children: /*#__PURE__*/jsx("ul", {
      children: listItems
    })
  }));
};

var _excluded$1 = ["title", "children", "className", "isOpen", "hasTitleDivider", "handleClose"];
var _templateObject$1, _templateObject2, _templateObject3;
var headerTokens = {
  size: {
    height: {
      navbar: {
        default: {
          value: pxToRem(64)
        },
        sm: {
          value: pxToRem(72)
        },
        md: {
          value: pxToRem(96)
        }
      }
    }
  }
};
var StyledCloseButton = styled.button.withConfig({
  displayName: "SlideoutMenu__StyledCloseButton",
  componentId: "lui__sc-8pev43-0"
})(["background-color:", ";border:0;margin:0;padding:0;width:", ";height:", ";color:", ";position:absolute;top:", ";right:", ";", " &:hover{background-color:#633482;}"], _ref => {
  var {
    theme
  } = _ref;
  return theme.color.interaction.main;
}, pxToRem(40), pxToRem(40), _ref2 => {
  var {
    theme
  } = _ref2;
  return theme.color.text.inverse;
}, pxToRem(16), pxToRem(16), gte('md')(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n    top: ", ";\n  "])), pxToRem(28)));

/**
 * @todo z-index: tokenise z-index to make it easier to manage levels
 */

var StyledSlideoutMenu = styled(SlideoutMenuBase).withConfig({
  displayName: "SlideoutMenu__StyledSlideoutMenu",
  componentId: "lui__sc-8pev43-1"
})(["background-color:", ";overflow-y:scroll;color:", ";z-index:999;"], _ref3 => {
  var {
    theme
  } = _ref3;
  return theme.color.fill.contrast;
}, _ref4 => {
  var {
    theme
  } = _ref4;
  return theme.color.text.inverse;
});
var StyledSlideoutHR = styled.hr.withConfig({
  displayName: "SlideoutMenu__StyledSlideoutHR",
  componentId: "lui__sc-8pev43-2"
})(["margin:0 ", " ", " ", ";border:0;height:0;border-top:1px solid ", ";"], pxToRem(16), pxToRem(12), pxToRem(16), _ref5 => {
  var {
    theme
  } = _ref5;
  return theme.color.text.inverse;
});
var StyledSlideoutHeader = styled.div.withConfig({
  displayName: "SlideoutMenu__StyledSlideoutHeader",
  componentId: "lui__sc-8pev43-3"
})(["padding-right:", ";padding-left:", ";min-height:", ";display:flex;align-items:center;", " ", ""], pxToRem(72), pxToRem(16), headerTokens.size.height.navbar.default.value, gte('sm')(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    min-height: ", ";\n  "])), headerTokens.size.height.navbar.sm.value), gte('md')(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    min-height: ", ";\n  "])), headerTokens.size.height.navbar.md.value));
var StyledSlideoutContent = styled.div.withConfig({
  displayName: "SlideoutMenu__StyledSlideoutContent",
  componentId: "lui__sc-8pev43-4"
})(["display:flex;flex-direction:column;height:100%;"]);
var SlideoutMenu = _ref6 => {
  var {
      title,
      children,
      className,
      isOpen,
      hasTitleDivider = true,
      handleClose
    } = _ref6,
    props = _objectWithoutProperties(_ref6, _excluded$1);
  var globalProps = filterGlobalProps(props);
  var theme = useTheme();
  return /*#__PURE__*/jsxs(StyledSlideoutMenu, _objectSpread2(_objectSpread2(_objectSpread2({
    handleClose: handleClose,
    isOpen: isOpen
  }, globalProps), props), {}, {
    children: [/*#__PURE__*/jsxs(StyledSlideoutContent, {
      children: [/*#__PURE__*/jsx(StyledSlideoutHeader, {
        children: /*#__PURE__*/jsx(Text, {
          variant: "title2",
          tag: "h2",
          isInverse: true,
          children: title
        })
      }), hasTitleDivider && /*#__PURE__*/jsx(StyledSlideoutHR, {}), children]
    }), /*#__PURE__*/jsxs(StyledCloseButton, {
      type: "button",
      onClick: handleClose,
      children: [/*#__PURE__*/jsx(Close, {
        color: theme.color.text.inverse,
        width: "1.5rem",
        height: "1.5rem"
      }), /*#__PURE__*/jsxs(SrOnlySpan, {
        children: ["Close ", title]
      })]
    })]
  }));
};

var TalkToExpertButton = _ref => {
  var {
    openCommPanel,
    customerOwner
  } = _ref;
  var {
    cmsNavbarBrokerNameButton
  } = useFlags();
  var buttonText = customerOwner !== null && customerOwner !== void 0 && customerOwner.firstName && cmsNavbarBrokerNameButton ? "Talk to ".concat(customerOwner.firstName) : 'Talk to a broker';
  var handleClick = () => {
    openCommPanel();
    var event = {
      event_name: 'Button Clicked',
      category: EventCategory.NAVBAR,
      text: buttonText,
      position: EventCategory.CMS,
      customerType: CustomerType.CUSTOMER,
      buttonType: ButtonType.SECONDARY
    };
    analytics(event);
  };
  return /*#__PURE__*/jsx(Button$1, {
    variant: "secondary",
    "data-component": "navbar-button-talk-to-expert",
    isInverse: true,
    width: "100%",
    onPress: handleClick,
    minWidth: pxToRem(152),
    children: buttonText
  });
};

var APPLY_HREF = '/home-loans/basics';
var ApplyNowButton = _ref => {
  var {
    onClick,
    width,
    size
  } = _ref;
  var handleClick = () => {
    onClick === null || onClick === void 0 || onClick();
    var event = {
      event_name: 'Button Clicked',
      category: EventCategory.NAVBAR,
      text: 'Apply now',
      position: EventCategory.CMS,
      customerType: CustomerType.CUSTOMER,
      buttonType: ButtonType.PRIMARY
    };
    analytics(event);
  };
  return /*#__PURE__*/jsx(AnchorButton, {
    width: width,
    onPress: handleClick,
    href: APPLY_HREF,
    variant: "primary",
    isInverse: true,
    size: size,
    children: "Apply now"
  });
};

var PrimaryCTA = _ref => {
  var {
    application,
    handleApplyNowClick
  } = _ref;
  return !(application !== null && application !== void 0 && application.id) ? /*#__PURE__*/jsx(ApplyNowButton, {
    onClick: handleApplyNowClick,
    width: "100%"
  }) : /*#__PURE__*/jsx(AnchorButton, {
    onPress: () => {
      var event = {
        event_name: 'Button Clicked',
        category: EventCategory.NAVBAR,
        text: 'Continue Application',
        position: EventCategory.CMS,
        customerType: CustomerType.CUSTOMER,
        buttonType: ButtonType.PRIMARY
      };
      analytics(event);
    },
    href: "/v2/dashboard/application/".concat(application.id),
    variant: "primary",
    isInverse: true,
    width: "100%",
    children: "Continue Application"
  });
};

var _excluded = ["navOptions"];
var _templateObject;
var HamburgerCtaBlock = _ref => {
  var {
    handleApplyNowClick,
    customerOwner,
    application,
    openCommPanel
  } = _ref;
  return /*#__PURE__*/jsx(MenuPadding, {
    children: /*#__PURE__*/jsxs(Spacer, {
      ygap: "12",
      children: [/*#__PURE__*/jsx(PrimaryCTA, {
        handleApplyNowClick: handleApplyNowClick,
        application: application
      }), /*#__PURE__*/jsx(TalkToExpertButton, {
        customerOwner: customerOwner,
        openCommPanel: openCommPanel
      })]
    })
  });
};
var StyledWrapperForButtonHack = styled.div.withConfig({
  displayName: "HamburgerMenu__StyledWrapperForButtonHack",
  componentId: "lui__sc-302min-0"
})(["button{padding:0;margin-left:0.75rem;", "}"], gte('sm')(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      margin-left: .25rem; // Make sure focus outline doesn't get cut off by preceding links with bg colour\n    "]))));
var HamburgerMenu = _ref2 => {
  var {
      navOptions
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded);
  var {
    showMenu,
    toggleMenu
  } = useSlideoutMenu();
  var theme = useTheme();
  var handleClick = () => {
    toggleMenu();
    var event = {
      event_name: 'Menu Clicked',
      category: EventCategory.NAVBAR,
      menuName: 'Hamburger Menu',
      position: EventCategory.CMS,
      customerType: CustomerType.CUSTOMER
    };
    analytics(event);
  };
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(StyledWrapperForButtonHack, {
      children: /*#__PURE__*/jsxs(Button$1, {
        onPress: handleClick,
        ariaExpanded: showMenu,
        variant: "text",
        size: "sm",
        isInverse: true,
        width: "auto",
        minWidth: "auto",
        children: [/*#__PURE__*/jsx(SrOnlySpan, {
          children: "Open main menu"
        }), /*#__PURE__*/jsx(Menu, {
          width: "1.5rem",
          height: "1.5rem",
          color: theme.color.text.inverse
        })]
      })
    }), /*#__PURE__*/jsxs(SlideoutMenu, {
      isOpen: showMenu,
      handleClose: toggleMenu,
      title: "Menu",
      children: [/*#__PURE__*/jsx(HamburgerCtaBlock, _objectSpread2({}, props)), /*#__PURE__*/jsx(Nav, {
        navOptions: navOptions,
        isSlideout: true
      })]
    })]
  });
};

var DropdownPrimaryContent = styled.div.withConfig({
  displayName: "AccountMenu__DropdownPrimaryContent",
  componentId: "lui__sc-4ssigl-0"
})(["", ";padding-top:", ";background-color:", ";flex-grow:1;"], Px, pxToRem(16), _ref => {
  var {
    theme
  } = _ref;
  return theme.color.fill.contrast;
});
var DropwdownSecondaryContent = styled.div.withConfig({
  displayName: "AccountMenu__DropwdownSecondaryContent",
  componentId: "lui__sc-4ssigl-1"
})(["padding-bottom:", ";background-color:#331745;"], pxToRem(24));
var LOGGEDIN_TEXT = 'My Account';
var LOGGEDOUT_TEXT = 'Login';
var MANAGE_APP_TEXT = 'Manage application';
var DropdownHeader = () => /*#__PURE__*/jsx(Fragment, {
  children: /*#__PURE__*/jsx(Text, {
    tag: "h2",
    variant: "title4",
    isInverse: true,
    children: "Loan application login"
  })
});
var DropdownHeaderLoggedIn = () => /*#__PURE__*/jsxs(Fragment, {
  children: [/*#__PURE__*/jsx(Text, {
    tag: "h2",
    variant: "title4",
    isInverse: true,
    children: "Manage your loan applications"
  }), /*#__PURE__*/jsx(StyledHR, {})]
});
var LoggedInContent = _ref2 => {
  var {
    handleApplyNowClick,
    application,
    customerOwner,
    openCommPanel,
    onLogout
  } = _ref2;
  var {
    referAFriend
  } = useFlags();
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs(DropdownPrimaryContent, {
      style: {
        flexGrow: '0'
      },
      children: [/*#__PURE__*/jsx(DropdownHeaderLoggedIn, {}), /*#__PURE__*/jsx("div", {
        style: {
          marginBottom: '.75rem'
        },
        children: /*#__PURE__*/jsx(PrimaryCTA, {
          handleApplyNowClick: handleApplyNowClick,
          application: application
        })
      }), /*#__PURE__*/jsx(TalkToExpertButton, {
        openCommPanel: openCommPanel,
        customerOwner: customerOwner
      })]
    }), /*#__PURE__*/jsxs("div", {
      style: {
        marginTop: '.75rem'
      },
      children: [/*#__PURE__*/jsx(MenuLink, {
        href: "/dashboard/applications",
        onClick: () => {
          var event = {
            event_name: 'Link Clicked',
            category: EventCategory.NAVBAR,
            position: EventCategory.CMS,
            text: 'My Applications',
            linkType: 'LinkToPage',
            customerType: CustomerType.CUSTOMER
          };
          analytics(event);
        },
        children: "My Applications"
      }), /*#__PURE__*/jsx(MenuLink, {
        href: "/property-report/my-properties",
        onClick: () => {
          var event = {
            event_name: 'Link Clicked',
            category: EventCategory.NAVBAR,
            position: EventCategory.CMS,
            text: 'Property reports',
            linkType: 'LinkToPage',
            customerType: CustomerType.CUSTOMER
          };
          analytics(event);
        },
        children: "Property reports"
      }), referAFriend && /*#__PURE__*/jsx(MenuLink, {
        href: "/referral",
        onClick: () => {
          var event = {
            event_name: 'Link Clicked',
            category: EventCategory.NAVBAR,
            position: EventCategory.CMS,
            text: 'Refer a friend',
            linkType: 'LinkToPage',
            customerType: CustomerType.CUSTOMER
          };
          analytics(event);
        },
        children: "Refer a friend"
      }), /*#__PURE__*/jsx(MenuButton, {
        onClick: onLogout,
        children: "Sign out"
      })]
    })]
  });
};
var MENU_LINKS = [{
  label: 'Aussie Select',
  link: 'https://online.aussie.com.au/AHL/BankFast-Username-Logon#sst'
}, {
  label: 'Aussie Elevate',
  link: 'https://www.adelaidebank.com.au/mortgage-managers/aussieelevate/home/'
}, {
  label: 'Aussie Activate',
  link: 'https://www.lsn.com.au/LsnWeb/faces/LsnrLogin.jsp?EWF_FORM_NAME=0001939&EWF_BUTTON_Submit=Submit'
}, {
  label: 'Aussie Edge',
  link: 'https://www.adelaidebank.com.au/mortgage-managers/aussieedge/home/home/'
}, {
  label: 'All online banking logins',
  link: 'https://www.aussie.com.au/get-in-touch/log-in-page/'
}
// {
//   label: 'Aussie IQ, Aussie Optimizer and all other Aussie Home Loans settled before 2012',
//   link: 'https://aussie.openportal.com.au/portal/ahl/#/',
// },
];
var LoggedOutContent = () => {
  var _window, _window2;
  var brand = getBrandFromHostname();
  var env = getEnvFromHostname((_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.hostname);
  var signInURL = getSignInURL(brand, env, (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.location) === null || _window2 === void 0 ? void 0 : _window2.href);
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs(DropwdownSecondaryContent, {
      children: [/*#__PURE__*/jsx(MenuPaddingAlt, {
        children: /*#__PURE__*/jsx(Text, {
          tag: "h2",
          variant: "title4",
          isInverse: true,
          children: "Online banking login"
        })
      }), MENU_LINKS.map((menuLink, i) => /*#__PURE__*/jsx(MenuLink, {
        href: menuLink.link,
        isExternal: true,
        background: "darker",
        onClick: () => {
          var event = {
            event_name: 'Link Clicked',
            category: EventCategory.NAVBAR,
            position: EventCategory.CMS,
            text: menuLink.label,
            linkType: 'LinkToPage',
            customerType: CustomerType.CUSTOMER
          };
          analytics(event);
        },
        children: menuLink.label
      }, i))]
    }), /*#__PURE__*/jsxs(DropdownPrimaryContent, {
      children: [/*#__PURE__*/jsx(DropdownHeader, {}), /*#__PURE__*/jsx("div", {
        style: {
          marginTop: '1.5rem',
          marginBottom: '1.5rem'
        },
        children: /*#__PURE__*/jsx(AnchorButton, {
          width: "100%",
          variant: "secondary",
          isInverse: true,
          href: signInURL,
          onPress: () => {
            var event = {
              event_name: 'Button Clicked',
              category: EventCategory.NAVBAR,
              text: MANAGE_APP_TEXT,
              position: EventCategory.CMS,
              customerType: CustomerType.CUSTOMER,
              buttonType: ButtonType.SECONDARY
            };
            analytics(event);
          },
          children: MANAGE_APP_TEXT
        })
      })]
    })]
  });
};
var AccountDropdown = _ref3 => {
  var {
    application,
    session,
    handleApplyNowClick,
    teamMember,
    customerOwner,
    openCommPanel,
    onLogout
  } = _ref3;
  var isAuthenticated = (session === null || session === void 0 ? void 0 : session.status) === Status.Authenticated;
  return /*#__PURE__*/jsx(NavDropdown, {
    label: isAuthenticated ? LOGGEDIN_TEXT : LOGGEDOUT_TEXT,
    align: "right",
    minDropdownWidth: "18.75rem",
    onClick: () => {
      var event = {
        event_name: 'Menu Clicked',
        category: EventCategory.NAVBAR,
        menuName: isAuthenticated ? LOGGEDIN_TEXT : LOGGEDOUT_TEXT,
        position: 'CMS',
        customerType: CustomerType.CUSTOMER
      };
      analytics(event);
    },
    children: isAuthenticated ? /*#__PURE__*/jsx(LoggedInContent, {
      teamMember: teamMember,
      customerOwner: customerOwner,
      application: application,
      handleApplyNowClick: handleApplyNowClick,
      openCommPanel: openCommPanel,
      onLogout: onLogout
    }) : /*#__PURE__*/jsx(LoggedOutContent, {})
  });
};
var AccountSlideoutMenu = _ref4 => {
  var {
    session,
    application,
    teamMember,
    customerOwner,
    handleApplyNowClick,
    openCommPanel,
    onLogout
  } = _ref4;
  var {
    showMenu,
    toggleMenu
  } = useSlideoutMenu();
  var isAuthenticated = (session === null || session === void 0 ? void 0 : session.status) === Status.Authenticated;
  var loggedInOutText = isAuthenticated ? LOGGEDIN_TEXT : LOGGEDOUT_TEXT;
  var handleClick = () => {
    toggleMenu();
    var event = {
      event_name: 'Menu Clicked',
      category: EventCategory.NAVBAR,
      menuName: loggedInOutText,
      position: 'CMS',
      customerType: CustomerType.CUSTOMER
    };
    analytics(event);
  };
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx(ShowAtMediumOnly, {
      children: /*#__PURE__*/jsx(NavButton, {
        "aria-expanded": showMenu,
        onClick: handleClick,
        isOpen: showMenu,
        children: loggedInOutText
      })
    }), /*#__PURE__*/jsx(ShowAtSmallOnly, {
      children: /*#__PURE__*/jsx(Button$1, {
        ariaExpanded: showMenu,
        onPress: handleClick,
        variant: "primary",
        size: "sm",
        isInverse: true,
        children: loggedInOutText
      })
    }), /*#__PURE__*/jsx(SlideoutMenu, {
      isOpen: showMenu,
      handleClose: toggleMenu,
      title: loggedInOutText,
      hasTitleDivider: false,
      children: isAuthenticated ? /*#__PURE__*/jsx(LoggedInContent, {
        teamMember: teamMember,
        customerOwner: customerOwner,
        application: application,
        handleApplyNowClick: handleApplyNowClick,
        openCommPanel: openCommPanel,
        onLogout: onLogout
      }) : /*#__PURE__*/jsx(LoggedOutContent, {})
    })]
  });
};

var CtaNav = _ref => {
  var {
    handleApplyNowClick,
    session,
    application,
    customerOwner,
    teamMember,
    openCommPanel,
    onLogout
  } = _ref;
  return /*#__PURE__*/jsxs(Spacer, {
    xalign: "center",
    children: [/*#__PURE__*/jsx(ShowFromTweakLarge, {
      children: /*#__PURE__*/jsx(TalkToExpertButton, {
        openCommPanel: openCommPanel,
        customerOwner: customerOwner
      })
    }), /*#__PURE__*/jsx(ShowFromSmall, {
      children: /*#__PURE__*/jsx(PrimaryCTA, {
        handleApplyNowClick: handleApplyNowClick,
        application: application
      })
    }), /*#__PURE__*/jsx(ShowFromMedium, {
      children: /*#__PURE__*/jsx(AccountDropdown, {
        handleApplyNowClick: handleApplyNowClick,
        session: session,
        teamMember: teamMember,
        customerOwner: customerOwner,
        application: application,
        openCommPanel: openCommPanel,
        onLogout: onLogout
      })
    }), /*#__PURE__*/jsx(HideFromMedium, {
      children: /*#__PURE__*/jsx(AccountSlideoutMenu, {
        handleApplyNowClick: handleApplyNowClick,
        session: session,
        teamMember: teamMember,
        customerOwner: customerOwner,
        application: application,
        openCommPanel: openCommPanel,
        onLogout: onLogout
      })
    })]
  });
};

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}

var getApplications = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(function* (session, customerId, limit, orderBy) {
    var response = yield axios.get("/v1/applications/", {
      baseURL: getAPIBaseURL(session.environment),
      headers: {
        Authorization: "Bearer ".concat(session.token),
        'Content-Type': 'application/json'
      },
      params: _objectSpread2(_objectSpread2(_objectSpread2({}, customerId && {
        customerId
      }), limit && {
        limit
      }), orderBy && {
        orderBy
      })
    });
    return response.data;
  });
  return function getApplications(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

var useApplication = session => {
  var [application, setApplication] = React.useState();
  var {
    onException
  } = useError();
  React.useEffect(() => {
    if (session.status === Status.Authenticated) {
      var _session$identity;
      getApplications(session, (_session$identity = session.identity) === null || _session$identity === void 0 ? void 0 : _session$identity.id, 1, 'updatedAt').then(res => {
        var applications = res.data;
        var mostRecentlyUpdatedApplication = applications[0];
        setApplication(mostRecentlyUpdatedApplication);
      }).catch(error => {
        onException(new Error("@lendi/navbar: unable to fetch application: ".concat(error)));
      });
    } else {
      setApplication(undefined);
    }
  }, [session, onException]);
  return application;
};

var HeaderWithContext = _ref => {
  var {
    // Public props
    handleApplyNow,
    onLogout,
    navOptions = [],
    // Internal props, from ChatProps
    isCommPanelOpen,
    closeCommPanel,
    openCommPanel: _openCommPanel,
    customerOwner
  } = _ref;
  var session = useSession();
  var application = useApplication(session);

  //to set AHL value in session storage for funnel1 journey
  useAHLParam();
  return /*#__PURE__*/jsx(HeaderBase, {
    navSlot: /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(ShowFromTweakLarge, {
        children: /*#__PURE__*/jsx(Nav, {
          navOptions: navOptions
        })
      }), /*#__PURE__*/jsx(HideFromTweakLarge, {
        children: /*#__PURE__*/jsx(HamburgerMenu, {
          handleApplyNowClick: handleApplyNow,
          application: application,
          customerOwner: customerOwner,
          navOptions: navOptions,
          openCommPanel: () => isCommPanelOpen ? closeCommPanel() : _openCommPanel()
        })
      })]
    }),
    ctaSlot: /*#__PURE__*/jsx(CtaNav, {
      handleApplyNowClick: handleApplyNow,
      application: application,
      session: session,
      customerOwner: customerOwner,
      openCommPanel: () => isCommPanelOpen ? closeCommPanel() : _openCommPanel(),
      onLogout: onLogout
    })
  });
};
var Header = withErrorProvider(withLendiLDProvider(withCommPanel(HeaderWithContext)));

/* eslint-disable camelcase */

var ApplicationStage = /*#__PURE__*/function (ApplicationStage) {
  ApplicationStage["started_application"] = "started_application";
  ApplicationStage["finished_funnel2"] = "finished_funnel2";
  ApplicationStage["finished_funnel3"] = "finished_funnel3";
  ApplicationStage["finalised_application"] = "finalised_application";
  ApplicationStage["loan_selected"] = "loan_selected";
  return ApplicationStage;
}({});

export { ApplicationStage, GuestNavbar, Header, MultiNavbar, SimpleNavbar };
